import { Injectable } from '@angular/core';
import { PayrollService } from '../../hrms/service/payroll.service';
import { MainService } from '../../hrms/service/main.service';
import { MainService as portal_main } from '../../portal/service/main.service';
import * as  pdfMake from "pdfmake/build/pdfmake";
import * as  pdfFonts from "pdfmake/build/vfs_fonts";
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { Workbook } from 'exceljs';
// import * as fs from 'file-saver';
import * as  fs from "file-saver";
import Swal from 'sweetalert2';
import { EstablishService } from '../../hrms/service/establish.service';
import { session } from 'src/environments/environment.session';
import { GratuityService } from '../../hrms/service/gratuity.service';
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';

declare var $: any
(pdfMake as any).vfs = (pdfFonts as any).default.vfs;
@Injectable({
  providedIn: 'root'
})
export class PrintSalBillService {
  erpUser: any;
  constructor(public estservice: EstablishService, private mainService: MainService,
    private payrollService: PayrollService, private spinner: NgxSpinnerService,
    private portal_main: portal_main,private utf8EncodingService:Utf8EncodingService,
    private gratuityService: GratuityService
  ) {
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    this.b_acct_id = this.erpUser.b_acct_id;
  }
  b_acct_id: any;
  monthObj: any = { '1': 'January', '2': 'February', '3': 'March', '4': 'April', '5': 'May', '6': 'June', '7': 'July', '8': 'August', '9': 'September', '10': 'October', '11': 'November', '12': 'December' }
  monthObjShort = { '1': 'JAN', '2': 'FEB', '3': 'MAR', '4': 'APR', '5': 'MAY', '6': 'JUN', '7': 'JUL', '8': 'AUG', '9': 'SEP', '10': 'OCT', '11': 'NOV', '12': 'DEC' }
  monthEnd = { '1': 31, '2': 28, '3': 31, '4': 30, '5': 31, '6': 30, '7': 31, '8': 31, '9': 30, '10': 31, '11': 30, '12': 31 }


  getNumberFormat(num: any) {
    return num.toString().padStart(3, "0")
  }
  allcostcenter: any = []
  async getallcostcenter(erpUser: any) {
    this.allcostcenter = []
    let obj: any = {}
    obj["b_acct_id"] = erpUser.b_acct_id;
    obj["leaf_node_type"] = 'District'
    obj["module_cd"] = 'HR'
    obj["status"] = 'ACTIVE'
    let resp = await this.estservice.getcostcenter(JSON.stringify(obj))
    if (resp["error"] == false) {
      // this.allcostcenter.push({leaf_cd: -1, leaf_value: "All District" })
      // for(let i=0;i<resp.data.length;i++){
      //   this.allcostcenter.push(resp.data[i])
      // }
      this.allcostcenter = resp.data

      this.allcostcenter = this.allcostcenter.filter((item: any) => {
        if (item.module_cd && typeof item.module_cd === 'string') {
          return item.module_cd.includes("HR");
        }
        return false; // or true depending on your logic if module_cd is not a string
      });
      // this.allcostcenter.unshift({ leaf_cd: -1, leaf_value: "All District" })
      this.allcostcenter.unshift({ leaf_cd: -1, leaf_value: "All District" })




    }
  }

  printdata: any = []
  alldata: any = []
  leaf_cd: any[] | undefined;
  async printdaarreardata(billIdObj: any, erpUser: any, type: any) {
    this.leaf_cd = []

    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['arrear_id'] = billIdObj['arrear_id'];
    await this.getallcostcenter(erpUser)
    if (billIdObj['district'] != undefined) {

      if (billIdObj['district'] == -1) {
        const arrIdsToRemove = [35, 681]
        this.allcostcenter = this.allcostcenter.filter((item: any) => !arrIdsToRemove.includes(item.leaf_cd));
        this.leaf_cd = this.allcostcenter.map((item: any) => item.leaf_cd).filter((id: any) => id !== "-1");

        obj["dist"] = this.leaf_cd
      }
      else {
        obj["dist"] = billIdObj['district']
      }
    }
    else {
      obj["dist"] = billIdObj['district']
    }
    this.spinner.show();

    var resp1 = await this.payrollService.getarrear(JSON.stringify(obj));
    if (resp1['error'] == false) {
      this.spinner.hide();
      // var assigned_emp = this.dataAccessService.assignedEmp;
      //   for (let i = 0; i < resp1.data.length; i++) {
      //     var obj:any = new Object();
      //     obj = Object.assign({}, resp1.data[i]);
      //     if (assigned_emp[resp1.data[i]['arr_id']] != undefined) {
      //       this.alldata.push(obj)
      //     }
      //   }
      // }
      this.alldata = resp1['data']
    }
    this.printdata = []
    this.printdata = this.alldata


    this.printdata.sort((a: any, b: any) => a.lvl2_value.localeCompare(b.lvl2_value));


    this.printdata = this.printdata.map((element: any) => {

      let ob = Object.assign({}, element);
      var data = JSON.parse(ob['data'])[0]
      element['print_arrear_end_dt'] = data['arrear_end_dt']
      element['print_fin_year'] = data['fin_year']
      element['print_month'] = data['month']
      element['print_arrear_start_dt'] = data['arrear_start_dt']
      element['print_basic'] = Number(data['basic'])

      element['print_da'] = Number(data['da'])
      element['print_new_da'] = Number(data['new_da'])
      element['print_old_da_amt'] = Number(data['oldda_amt'])
      element['print_new_da_amt'] = Number(data['new_da_amt'])
      element['basic+da'] = Number(data['basic']) + (Number(data['basic']) * data['new_da']) / 100

      element['print_emp_id'] = this.getNumberFormat(element['emp_id'])
      return element
    });
    let printObj: any = {}
    let printdata_temp: any = []
    printdata_temp = this.printdata
    for (let i = 0; i < printdata_temp.length; i++) {
      if (printObj[printdata_temp[i]['emp_id']] == undefined) {
        printObj[printdata_temp[i]['emp_id']] = [printdata_temp[i]]
      } else {
        printObj[printdata_temp[i]['emp_id']].push(printdata_temp[i])
      }
    }
    var txt: any = this.portal_main.accInfo['account_name'] + "(" + this.portal_main.accInfo['account_short_name'] + ")";

    var txt1: any = [this.portal_main.accInfo['address']]; // Wrap in an array
    var txt2: any = [` LIST OF DA ARREAR OF PROJECTS FOR THE ,${this.printdata[0]['arrear_start_dt']}  - ${this.printdata[0]['arrear_end_dt']}`];

    var dd: any = {
      pageSize: 'A4',
      header: function (currentPage: any, pageCount: any) {
        var arr = []
        var obj: any = { text: txt, alignment: 'center', margin: [72, 40], fontSize: 15, bold: true };
        arr.push(obj);
        return arr;
      },
      pageOrientation: 'landscape',
      pageMargins: [40, 60, 40, 60],
      content: [

      ]
    };

    var tb11: any = {
      layout: 'lightHorizontalLines',
      fontSize: 12,
      alignment: 'center',
      bold: true,


      table: {
        headerRows: 1,

        widths: ['*'],
        body: [txt1]
      }
    };
    dd.content.push(tb11);

    var tb12: any = {
      layout: 'lightHorizontalLines',
      fontSize: 12,
      alignment: 'center',
      bold: true,

      table: {
        headerRows: 1,

        widths: ['*'],
        body: [txt2]
      }
    };
    dd.content.push(tb12);

    dd.content.push({ text: " " });

    var header0: any = {
      columns: [
        {
          width: '*',
          text: 'DA Arrear Report',
          bold: true,
          alignment: 'center'
        }
      ],

    }
    dd.content.push({ canvas: [{ type: 'line', x1: 0, y1: 0, x2: 760, y2: 0, lineWidth: 0.5 }] });
    dd.content.push(header0);
    dd.content.push({ canvas: [{ type: 'line', x1: 0, y1: 0, x2: 760, y2: 0, lineWidth: 0.5 }] });
    let f_flag = false;

    let grand_total = 0;
    let bank_total = 0;
    let pf_total = 0;
    let cash_total = 0;
    let total_count = 0;
    let count = 1;
    let old_da = 0
    let new_da = 0
    old_da = printdata_temp[0]['print_da'];
    new_da = printdata_temp[0]['print_new_da']

    // for (let p = 0; p < sections.length; p++) {

    // if (sections[p] == undefined || sections[p] == 'undefined' || sections[p] == null || sections[p] == 'null') {
    //   continue;
    // }
    let sec_total_count = 0;
    let sec_grand_total = 0;
    let sec_bank_total = 0;
    let sec_cash_total = 0;
    let sec_pf_total = 0;

    // var sectionText:any = { text: 'Section : ' + sections[p], fontSize: 8 };
    // if (f_flag) {
    //   sectionText['pageBreak'] = 'before'
    // }
    f_flag = true;

    // dd.content.push(sectionText);


    var tbl: any = {

      layout: 'lightHorizontalLines',
      fontSize: 10,
      table: {

        headerRows: 1,
        // widths: ['5%', '15%', '13%', '13%', '13%', '13%', '10%'],
        widhts: ['*', '*', '*', '*', '*', '*', '*', '*', '*', '*'],

        body: [
          ['S.No.', 'Employee\nDetail', 'IFSC CODE', 'ACCOUNT NUMBER', 'Section Code', 'Basic', 'Month-Year', 'Drawn(' + old_da + " %)", 'Due(' + new_da + " %)", 'DA Arrear']
        ]
      }
    };
    dd.content.push(tbl);











    let emp: any = Object.keys(printObj);

    for (var l = 0; l < emp.length; l++) {



      let total: any = 0;
      let emp_da: any = printObj[emp[l]];
      let flag: any = true;
      let new_da_amt: any = 0;
      let total_basic: any = 0
      let old_da_amt: any = 0;
      for (let i = 0; i < emp_da.length; i++) {
        let arr = [];
        if (flag) {
          arr.push(count)
          arr.push(emp_da[i]['print_emp_id'] + "\n"
            + emp_da[i]['emp_name'] + "\n"
            + emp_da[i]['designation_code'])
          // arr.push(emp_da[i]['print_emp_id'] + "\n"
          //   + emp_da[i]['emp_name'] + "\n"
          //   + this.mainService.codeValueShowObj['HR0011'][emp_da[i]['designation_code']])
          arr.push(emp_da[i]['acct_no'])
          arr.push(emp_da[i]['ifsc_code'])
          arr.push(emp_da[i]['lvl2_value'])
          flag = false;
        } else {
          // arr.push('')
          arr.push('')
          arr.push('')
          arr.push('')
          arr.push('')
          arr.push('')
        }
        arr.push((emp_da[i].print_basic).toFixed(0))
        arr.push(this.portal_main.codeValueShowObj['HR0024'][emp_da[i].print_month] + "-" + emp_da[i].print_fin_year)
        arr.push(((emp_da[i].print_basic * emp_da[i].print_da) / 100).toFixed(0))
        arr.push(((emp_da[i].print_basic * emp_da[i].print_new_da) / 100).toFixed(0))
        arr.push((emp_da[i].per_mnth_amt).toFixed(0))
        // arr.push('')
        // arr.push('')
        // arr.push('')
        total_basic = total_basic + emp_da[i].print_basic
        total = total + emp_da[i].per_mnth_amt
        old_da_amt = old_da_amt + emp_da[i].print_old_da_amt
        new_da_amt = new_da_amt + emp_da[i].print_new_da_amt
        grand_total = grand_total + emp_da[i].per_mnth_amt
        sec_grand_total = sec_grand_total + emp_da[i].per_mnth_amt
        dd.content[dd.content.length - 1].table.body.push(arr);
      }
      let arr = [];
      arr.push('')
      arr.push('')
      arr.push('')
      arr.push('')
      arr.push('TOTAL AMOUNT')
      arr.push((total_basic).toFixed(0))
      arr.push('')
      arr.push((old_da_amt).toFixed(0))
      arr.push((new_da_amt).toFixed(0))

      arr.push((total).toFixed(0));


      total_count++;
      sec_total_count++;
      count++;
      dd.content[dd.content.length - 1].table.body.push(arr);
    }

    let arr = [];
    arr.push('')
    arr.push('')
    arr.push('Section Total Employee :')
    arr.push(sec_total_count)
    arr.push('')
    arr.push('')
    arr.push('')
    arr.push('')
    arr.push('Section Grand Total:')
    arr.push((sec_grand_total).toFixed(0))
    // arr.push(sec_bank_total)
    // arr.push(sec_pf_total)
    // arr.push(sec_cash_total)

    bank_total = bank_total + sec_bank_total;
    pf_total = pf_total + sec_pf_total;
    cash_total = cash_total + sec_cash_total;


    dd.content[dd.content.length - 1].table.body.push(arr);

    // }

    if (type == 'TASK_DA_PRINT') {
      const pdfDoc = pdfMake.createPdf(dd);

      // Open PDF in a new tab
      pdfDoc.open();
    }
    else {

      pdfMake.createPdf(dd).download('DA_Arrear_Bill_Report');
    }



  }


  async printSalbill(req: any, erpUser: any, type: any) {
    this.b_acct_id = erpUser.b_acct_id;
    await this.getAllBill(req, type, erpUser);
  }

  async printSalbill1(req: any, erpUser: any, type: any) {
    this.b_acct_id = erpUser.b_acct_id;
    await this.getAllBill1(req, type, erpUser);
  }

  popup: any
  compare_arr: any = [];
  async showcomapredata(a: any, showcmp_data: any, erpUser: any) {
    this.spinner.show()
    let aa: any = []
    let newObj: any = {}
    showcmp_data['month'] = JSON.parse(showcmp_data['month'])
    newObj = Object.assign({}, showcmp_data)

    let a_cmp: any = a.pay_component_code
    if (a_cmp == "TOTAL PAY") {
      a_cmp = 'gross_pay'
    }
    if (a_cmp == 'NET PAY ') {
      a_cmp = 'net'
    }
    if (a_cmp == "TOTAL DED") {
      a_cmp = 'total'
    }
    showcmp_data["type"] = 'EXCEL'
    showcmp_data["dist_Data"] = newObj
    //  current data get/////////////////////////////////////
    await this.dataTopop(JSON.stringify(showcmp_data), erpUser, 'EXCEL')
    aa['current'] = this.currentmonth_userdata;
    aa['current'] = Object.values(aa['current'][0])






    //  previous data get/////////////////////////////////////
    let obj: any = Object.assign({}, showcmp_data)
    obj["bill_id"] = null
    obj['month'] = (Number(obj['month']) - 1)
    if (obj['month'] == "3") {
      obj["fin_year"] = Number(obj["fin_year"]) - 1
    }

    if (obj["dist_cd"] == -1) {
      obj["district"] = "Project"
    }
    obj["bill_type"] = 'SAL_BILL'
    obj["type"] = 'EXCEL'
    await this.dataTopop(JSON.stringify(obj), erpUser, 'EXCEL')
    aa['previous'] = this.currentmonth_userdata;
    aa['previous'] = Object.values(aa['previous'][0])





    ///////////////////////////////////////calulation over previous and current month data ///////////////////////////////////////



    this.spinner.show()

    let arr1: any = aa['current'];
    let arr2: any = aa['previous'];
    let newArr = [];
    this.compare_arr = []
    for (let i = 0; i < arr1.length; i++) {
      const empId: any = arr1[i]['emp_id'];
      const indexInArr2: any = arr2.findIndex((obj: any) => obj.emp_id === empId);
      if (indexInArr2 === -1) {
        this.compare_arr.push({
          'emp_id': empId,
          'emp_name': arr1[i]['emp_name'],
          'previous_amt': 0,
          'current_amt': Number(arr1[i][a_cmp].toFixed(0)),
          'diff_amt': Number(arr1[i][a_cmp].toFixed(0)) - 0  // Difference based on the comparison

          //       // 'diff_amt': previous_amt - current_amt // Difference based on the comparison
        });
        arr1.splice(i, 1);
      }
    }

    // Step 2: Remove emp_id from arr2 if it exists in arr1
    for (let i = 0; i < arr2.length; i++) {
      const empId = arr2[i]['emp_id'];
      const indexInArr1 = arr1.findIndex((obj: any) => obj.emp_id === empId);
      if (indexInArr1 === -1) {
        this.compare_arr.push({
          'emp_id': empId,
          'emp_name': arr2[i]['emp_name'],
          'previous_amt': Number(arr2[i][a_cmp].toFixed(0)),
          'current_amt': 0,
          'diff_amt': 0 - Number(arr2[i][a_cmp].toFixed(0))   // Difference based on the comparison

          //       // 'diff_amt': previous_amt - current_amt // Difference based on the comparison
        });
        arr2.splice(i, 1);
        i--; // Adjust lopps counter after removal
      }
    }


    for (let i = 0; i < arr1.length; i++) {
      for (let j = 0; j < arr2.length; j++) {
        if (arr1[i]['emp_id'] === arr2[j]['emp_id']) {
          if (Number(arr1[i][a_cmp].toFixed(0)) != Number(arr2[j][a_cmp].toFixed(0))) {
            this.compare_arr.push({
              'emp_id': arr1[i]['emp_id'],
              'emp_name': arr1[i]['emp_name'],
              'previous_amt': Number(arr2[i][a_cmp].toFixed(0)),
              'current_amt': Number(arr1[i][a_cmp].toFixed(0)),
              'diff_amt': Number(arr1[i][a_cmp].toFixed(0)) - Number(arr2[i][a_cmp].toFixed(0))   // Difference based on the comparison

              //       // 'diff_amt': previous_amt - current_amt // Difference based on the comparison
            });
          }
        }
      }
    }




























    this.compare_arr = this.compare_arr.filter((item: any) => item.diff_amt != 0);

    this.spinner.show()

    // let obj1 =Object.assign({},this.compare_arr)
    let obj1: any = {}
    obj1["b_acct_id"] = this.b_acct_id
    obj1["bill_id"] = JSON.parse(showcmp_data["bill_id"])
    obj1["node_cd"] = JSON.parse(showcmp_data["node_cd"])
    obj1["emp_id"] = this.compare_arr.map((item: any) => item.emp_id)
    let resp = await this.payrollService.getempdistrict(obj1)

    this.spinner.show()

    this.compare_arr = await this.addLeafValue(resp["data"], this.compare_arr);

    this.spinner.hide()
    return this.compare_arr

  }

  async addLeafValue(arr1: any, arr2: any) {
    arr2.forEach((item: any) => {
      const matchingItem = arr1.find((el: any) => el.emp_id == item.emp_id);
      if (matchingItem) {
        // Create a new key in the item object with the district name
        item['District'] = matchingItem.lvl2_value;

      }
    });
    return arr2
  }

  objtoUseInAccount = {}
  async dataTopop(req: any, erpUser: any, type: any) {
    this.popup = 'popup'
    await this.printSalbill1(req, erpUser, type)
  }
  async printSalbill2(req: any, erpUser: any, type: any) {
    this.b_acct_id = erpUser.b_acct_id;
    await this.getAllBill2(req, type, erpUser);
  }

  async getAllBill2(element: any, type: any, erpUser: any) {
    this.currentBillObj = { header: {}, allEmployees: [], data: {}, sums: {} };
    var element1 = JSON.parse(element);
    var obj: any = new Object();
    element1['b_acct_id'] = this.b_acct_id
    // obj['b_acct_id'] = this.b_acct_id;
    // obj['bill_id'] = element1['bill_id'];
    this.spinner.show()
    obj = element1;
    var obj1: any = new Object();
    obj1['b_acct_id'] = this.b_acct_id
    var resp1 = await this.payrollService.getAllComponent(JSON.stringify(obj1));
    if (resp1['error'] == false) {
      this.all_component = resp1.data;
    } else {
      return;
    }

    let obb: any = new Object();
    obb['emp_id'] = '';
    obb['emp_name'] = '';
    obb['designation_code'] = '';
    obb['grade_pay_code'] = '';
    obb['pay_band'] = '';
    obb['sal_acc'] = '';
    obb['pf'] = '';
    obb['pf_ifsc'] = '';

    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'PAY') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }

    obb['gross_pay'] = 0
    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'DED') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }
    obb['total'] = 0
    obb['net'] = 0;
    let obj11: any = {}
    this.arr = obj['data'].map((item: any) => item.bill_id)
    obj11["arr"] = this.arr
    obj11["b_acct_id"] = this.b_acct_id
    obj11['month'] = obj['month']
    obj11['year'] = obj['fin_year']
    obj11['bill_status_code'] = obj['bill_status_code']
    obj11['type'] = obj['type']

    // var resp = await this.payrollService.getselectedBill(JSON.stringify(obj11));
    var resp = await this.payrollService.getselectedBill(obj11);

    let resp11 = await this.payrollService.getAlluser(obj11);
    if (resp11["error"] == false) {
      this.AllUser = resp11.data
    }
    if (resp['error'] == false) {
      this.spinner.hide()
      var billObj: any = {};
      var header: any = "";
      var dt: any = resp['data'];
      // Create a map to store the designation codes by arr_id
      const designationMap: any = {};

      // Populate the map with designation codes from the second array
      this.AllUser.forEach((item: any) => {
        designationMap[item.arr_id] = item.designation_code;
      });

      dt.forEach((item: any) => {
        const arr_id = item.arr_id; // Assuming arr_id is stored in the 'id' field of the first array
        if (designationMap[arr_id]) {
          item.designation_code = designationMap[arr_id];
        }
      });
      const sectionMap: any = {}
      obj['data'].forEach((item: any) => {
        sectionMap[item.bill_id] = item.leaf_value;
      });
      dt.forEach((item: any) => {
        const bill_id = item.bill_id; // Assuming arr_id is stored in the 'id' field of the first array
        if (sectionMap[bill_id]) {
          item.leaf_value = sectionMap[bill_id];
        }
      });
      // Now, firstArray contains the designation_code from the second array
      if (dt.length > 0) {
        header = dt[0];
      }
      var grand: any = undefined;
      var month: any = "";
      var fin_year: any = "";
      var fixedarr: any = [];

      for (var i = 0; i < dt.length; i++) {

        if (billObj[dt[i]['section_code']] == undefined) {
          month = dt[i]['month'];
          fin_year = dt[i]['fin_year'];
          billObj[dt[i]['section_code']] = {};
          billObj[dt[i]['section_code']]['data'] = {};//{'BASIC':0.00,'DA':0.00,'DEP':0.00,'HRA':0.00,'MA':0.00,'VA':0.00,'WA':0.00,'miscpay':[],'LIC1':0.00,LIC2:0.00,LIC3:0.00,LIC4:0.00,LIC5:0.00,LIC6:0.00,LIC7:0.00,PF:0.00,GIS:0.00,IT:0.00,HRR:0.00,VD:0.00,VADV:0.00,BLDADV1:0.00,BLDADV2:0.00,BLDADV3:0.00,PFADV:0.00,PFADV1:0.00,PFADV2:0.00,BADV:0.00,EWF:0.00,miscded:[]};
          billObj[dt[i]['section_code']]['total'] = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          if (grand == undefined) {
            grand = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          }
        }
        if (billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]] == undefined) {
          fixedarr = []
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]] = Object.assign({}, obb);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['emp_id'] = (dt[i]['emp_id']);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['emp_name'] = dt[i]['emp_name']
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['month'] = dt[i]['month']
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['designation_code'] = dt[i]['designation_code']
          if (dt[i]['leaf_value'] != undefined) {
            billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['leaf_value'] = dt[i]['leaf_value']

          }

          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['grade_pay_code'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['pay_band'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['sal_acc'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['pf'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['pf_ifsc'] = ''
        }


        // if (dt[i]['pay_code'] == 'PAY') {
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]['gross_pay']] += dt[i]['pay_component_amt'];
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]['net']]+= dt[i]['pay_component_amt'];
        //   // ['net'] += dt[i]['pay_component_amt'];
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        // } else {
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]]['total'] += dt[i]['pay_component_amt'];
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]]['net'] -= dt[i]['pay_component_amt'];
        //   billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']+'-'+[dt[i]['month']]][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        // }

        if (dt[i]['pay_code'] == 'PAY') {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['gross_pay'] += dt[i]['pay_component_amt']
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['net'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        } else {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['total'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]]['net'] -= dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id'] + '-' + [dt[i]['month']]][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        }


      }
      if (type === 'PDF') {
        this.print(billObj, header, month, fin_year);
      } if (type === 'EXCEL') {
        this.exportExcel2(billObj, header, erpUser);

      }


      // this.spinner.hide()
    } else {
      // this.spinner.hide();
      // swal.fire("Error", "Error while printing pay bill", 'error')
    }
  }
  arr = []
  async getAllBill1(element: any, type: any, erpUser: any) {
    this.currentBillObj = { header: {}, allEmployees: [], data: {}, sums: {} };
    var element1 = JSON.parse(element);
    this.b_acct_id = erpUser.b_acct_id
    var obj: any = new Object();
    element1['b_acct_id'] = this.b_acct_id
    // obj['b_acct_id'] = this.b_acct_id;
    // obj['bill_id'] = element1['bill_id'];
    this.spinner.show()
    obj = element1;
    var obj1: any = new Object();
    obj1['b_acct_id'] = this.b_acct_id
    var resp1 = await this.payrollService.getAllComponent(JSON.stringify(obj1));
    if (resp1['error'] == false) {
      this.all_component = resp1.data;
    } else {
      return;
    }

    let obb: any = new Object();
    obb['emp_id'] = '';
    obb['emp_name'] = '';
    obb['designation_code'] = '';
    obb['grade_pay_code'] = '';
    obb['pay_band'] = '';
    obb['sal_acc'] = '';
    obb['pf'] = '';
    obb['pf_ifsc'] = '';

    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'PAY') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }

    obb['gross_pay'] = 0
    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'DED') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }
    obb['total'] = 0
    obb['net'] = 0;
    let obj11: any = {}
    let node_cd;
    if (obj['data']) {
      this.arr = obj['data'].map((item: any) => item.bill_id)

      if (!this.arr[0]) {
        this.arr = []
        node_cd = obj['data'].map((item: any) => item.node_cd)
        // if(obj['month'] == "4"){
        //   obj11['month'] = Number(obj['month']) -1
        //   obj11['year'] = Number(obj['fin_year'])-1
        // }


      }
    }
    else {
      this.arr = JSON.parse(obj['bill_id'])

      if (!this.arr) {
        this.arr = []

        var array = JSON.parse(obj['node_cd']); // Parse the string into an array
        var newArray = array.map(function (item: any) {
          return item.toString(); // Convert each element to string
        });

        node_cd = newArray
        // if(obj['month'] == "4"){
        //   obj11['month'] = Number(obj['month']) -1
        //   obj11['year'] = Number(obj['fin_year'])-1
        // }


      }
    }

    // else{
    obj11['month'] = obj['month']
    obj11['year'] = obj['fin_year']
    // }

    obj11["arr"] = this.arr
    obj11["node_cd"] = node_cd
    obj11["b_acct_id"] = this.b_acct_id

    obj11['bill_status_code'] = obj['bill_status_code']
    obj11['type'] = obj['type']
    obj11['check'] = obj["check"]
    obj11['district'] = obj["district"]
    obj11["bill_type"] = obj["bill_type"]
    if (obj["emp_id"]) {
      obj11["emp_id"] = obj["emp_id"]
    }

    // var resp = await this.payrollService.getselectedBill(JSON.stringify(obj11));
    var resp = await this.payrollService.getselectedBill(obj11);

    let resp11 = await this.payrollService.getAlluser(obj11);
    if (resp11["error"] == false) {
      this.AllUser = resp11.data
    }
    if (resp['error'] == false) {
      this.spinner.hide()
      var billObj: any = {};
      var header: any = "";
      var dt: any = resp['data'];
      this.objtoUseInAccount = dt['0']
      // Create a map to store the designation codes by arr_id
      const designationMap: any = {};

      // Populate the map with designation codes from the second array
      this.AllUser.forEach((item: any) => {
        designationMap[item.arr_id] = item.designation_code;
      });

      // Update the first array with designation codes
      dt.forEach((item: any) => {
        const arr_id = item.arr_id; // Assuming arr_id is stored in the 'id' field of the first array
        if (designationMap[arr_id]) {
          item.designation_code = designationMap[arr_id];
        }
      });

      const sectionMap: any = {}
      if (obj['data']) {

        obj['data'].forEach((item: any) => {
          sectionMap[item.bill_id] = item.leaf_value;
        });
      } else {
        // newArray.forEach((item:any )=> {
        //   sectionMap[item.bill_id] = newArray;
        // });
      }
      dt.forEach((item: any) => {
        const bill_id = item.bill_id; // Assuming arr_id is stored in the 'id' field of the first array
        if (sectionMap[bill_id]) {
          item.leaf_value = sectionMap[bill_id];
        }
      });
      // Now, firstArray contains the designation_code from the second array
      if (dt.length > 0) {
        header = dt[0];
      }
      var grand: any = undefined;
      var month: any = "";
      var fin_year: any = "";
      var fixedarr: any = [];

      for (var i = 0; i < dt.length; i++) {

        if (billObj[dt[i]['section_code']] == undefined) {
          month = dt[i]['month'];
          fin_year = dt[i]['fin_year'];
          billObj[dt[i]['section_code']] = {};
          billObj[dt[i]['section_code']]['data'] = {};//{'BASIC':0.00,'DA':0.00,'DEP':0.00,'HRA':0.00,'MA':0.00,'VA':0.00,'WA':0.00,'miscpay':[],'LIC1':0.00,LIC2:0.00,LIC3:0.00,LIC4:0.00,LIC5:0.00,LIC6:0.00,LIC7:0.00,PF:0.00,GIS:0.00,IT:0.00,HRR:0.00,VD:0.00,VADV:0.00,BLDADV1:0.00,BLDADV2:0.00,BLDADV3:0.00,PFADV:0.00,PFADV1:0.00,PFADV2:0.00,BADV:0.00,EWF:0.00,miscded:[]};
          billObj[dt[i]['section_code']]['total'] = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          if (grand == undefined) {
            grand = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          }

        }
        if (billObj[dt[i]['section_code']]['district'] == undefined) {
          billObj[dt[i]['section_code']]['district'] = {}
          billObj[dt[i]['section_code']]['district'] = element1['district']
        }
        if (billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']] == undefined) {
          fixedarr = []
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']] = Object.assign({}, obb);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['emp_id'] = (dt[i]['emp_id']);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['emp_name'] = dt[i]['emp_name']
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['designation_code'] = dt[i]['designation_code']
          if (dt[i]['leaf_value'] != undefined) {
            billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['leaf_value'] = dt[i]['leaf_value']

          }

          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['grade_pay_code'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pay_band'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['sal_acc'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pf'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pf_ifsc'] = ''
        }

        if (dt[i]['pay_code'] == 'PAY') {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['gross_pay'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['net'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        } else {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['total'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['net'] -= dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        }
        // billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['net'] = billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['gross_pay'] - billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['total'] ;

      }
      if (type === 'Task_Sal_Pdf') {
        // this.print(billObj, header, month, fin_year,obj);
        this.print111(billObj, header, month, fin_year, obj, type);
      }
      if (type === 'PDF') {
        this.print1(billObj, header, erpUser, type, month, fin_year);
      } if (type === 'EXCEL') {
        this.exportExcel1(billObj, header, erpUser, type);

      }
      // if (type === 'POPUP') {
      //   this.formatingdtaForPopup(billObj);

      // }


      // this.spinner.hide()
    } else {
      // this.spinner.hide();
      // swal.fire("Error", "Error while printing pay bill", 'error')
    }
  }

  currentBillObj: any
  all_component: any = []
  AllUser: any = []
  async getAllBill(element: any, type: any, erpUser: any) {
    this.currentBillObj = { header: {}, allEmployees: [], data: {}, sums: {} };
    if (typeof element === 'object') {
      var element1 = element
    } else {
      var element1 = JSON.parse(element);
    }

    var obj: any = new Object();
    element1['b_acct_id'] = this.b_acct_id
    // obj['b_acct_id'] = this.b_acct_id;
    // obj['bill_id'] = element1['bill_id'];
    obj = element1;
    var resp1 = await this.payrollService.getAllComponent(JSON.stringify(obj));
    if (resp1['error'] == false) {
      this.all_component = resp1.data;
    } else {
      return;
    }

    let obb: any = new Object();
    obb['emp_id'] = '';
    obb['emp_name'] = '';
    obb['designation_code'] = '';
    obb['grade_pay_code'] = '';
    obb['pay_band'] = '';
    obb['sal_acc'] = '';
    obb['pf'] = '';
    obb['pf_ifsc'] = '';

    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'PAY') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }

    obb['gross_pay'] = 0
    for (let i = 0; i < this.all_component.length; i++) {
      if (this.all_component[i]['pay_code'] == 'DED') {
        obb[this.all_component[i]['component_code']] = 0
      }
    }
    obb['total'] = 0
    obb['net'] = 0;

    var resp = await this.payrollService.getAllBill(JSON.stringify(obj));
    let resp11 = await this.payrollService.getAlluser(obj);
    if (resp11["error"] == false) {
      this.AllUser = resp11.data
    }
    if (resp['error'] == false) {

      var billObj: any = {};
      var header: any = "";
      var dt: any = resp['data'];
      // const empIdToDesignation = {
      //       [this.AllUser['arr_id']]: this.AllUser['designation_code'],
      //       // Add more mappings if needed
      //       };
      //       // Use the map function to add the new column based on emp_id
      //       const newArray = dt.map((obj) => ({
      //         ...obj,
      //         designation_code: empIdToDesignation[obj.arr_id] || "", // Add the desired property here
      //       }));

      if (dt.length > 0) {
        header = dt[0];
      }
      var grand: any = undefined;
      var month: any = "";
      var fin_year: any = "";
      var fixedarr: any = [];

      for (var i = 0; i < dt.length; i++) {
        if (billObj[dt[i]['section_code']] == undefined) {
          month = dt[i]['month'];
          fin_year = dt[i]['fin_year'];
          // if(billObj['leaf_value']=''){
          //   billObj['leaf_value']=''
          // }
          // billObj['leaf_value']=obj["leaf_value"]
          billObj[dt[i]['section_code']] = {};
          billObj[dt[i]['section_code']]['data'] = {};//{'BASIC':0.00,'DA':0.00,'DEP':0.00,'HRA':0.00,'MA':0.00,'VA':0.00,'WA':0.00,'miscpay':[],'LIC1':0.00,LIC2:0.00,LIC3:0.00,LIC4:0.00,LIC5:0.00,LIC6:0.00,LIC7:0.00,PF:0.00,GIS:0.00,IT:0.00,HRR:0.00,VD:0.00,VADV:0.00,BLDADV1:0.00,BLDADV2:0.00,BLDADV3:0.00,PFADV:0.00,PFADV1:0.00,PFADV2:0.00,BADV:0.00,EWF:0.00,miscded:[]};
          billObj[dt[i]['section_code']]['total'] = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          if (grand == undefined) {
            grand = { 'BASIC': 0.00, 'DA': 0.00, 'DEP': 0.00, 'HRA': 0.00, 'MA': 0.00, 'VA': 0.00, 'WA': 0.00, 'miscpay': [], 'LIC1': 0.00, LIC2: 0.00, LIC3: 0.00, LIC4: 0.00, LIC5: 0.00, LIC6: 0.00, LIC7: 0.00, PF: 0.00, NPS: 0.00, GIS: 0.00, IT: 0.00, HRR: 0.00, VD: 0.00, VADV: 0.00, BLDADV1: 0.00, BLDADV2: 0.00, BLDADV3: 0.00, PFADV: 0.00, PFADV1: 0.00, PFADV2: 0.00, BADV: 0.00, EWF: 0.00, miscded: [], total: 0.00, net: 0.00 };
          }
        }
        if (billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']] == undefined) {
          fixedarr = []
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']] = Object.assign({}, obb);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['emp_id'] = (dt[i]['emp_id']);
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['emp_name'] = dt[i]['emp_name']
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['designation_code'] = dt[i]['designation_code']
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['grade_pay_code'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pay_band'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['sal_acc'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pf'] = ''
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['pf_ifsc'] = ''
        }

        if (dt[i]['pay_code'] == 'PAY') {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['gross_pay'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['net'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        } else {
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['total'] += dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']]['net'] -= dt[i]['pay_component_amt'];
          billObj[dt[i]['section_code']]['data'][dt[i]['emp_id']][dt[i]['pay_component_code']] += dt[i]['pay_component_amt']

        }


      }
      if (type === 'Task_Sal_Pdf') {
        // this.print(billObj, header, month, fin_year,obj);
        this.print111(billObj, header, month, fin_year, obj, type);
      }
      if (type === 'PDF') {
        // this.print(billObj, header, month, fin_year,obj);
        this.print111(billObj, header, month, fin_year, obj, type);
      } if (type === 'EXCEL') {
        this.exportExcel(billObj, header, erpUser);

      }



      // this.spinner.hide()
    } else {
      // this.spinner.hide();
      // swal.fire("Error", "Error while printing pay bill", 'error')
    }
  }

  arr2: any = []

  print111(billObj: any, header: any, month: any, fin_year: any, showobj: any, type: any) {

    var file_name: any

    if (showobj['bill_desc'] == undefined) {
      file_name = header['bill_desc'];

    }
    else {
      file_name = showobj['bill_desc'];

    }
    //var txt = "VARANASASI DEVELOPMENT AUTHORITY(VDA)   Officers/THIRD/FOURTH Category EMPLOYEES STATEMENT FOR THE MONTH OF June,2020   PIRNT DATE: 2020-10-10"
    var txt: any = this.portal_main.accInfo['account_name'] + "(" + this.portal_main.accInfo['account_short_name'] + ")" + "   " + file_name + "   Date: " + header['accrual_date'];
    var dd: any = {
      pageSize: 'A3',
      header: function (currentPage: any, pageCount: any) {
        var obj: any = { text: txt + "     Page No. - " + currentPage, alignment: 'center', margin: [10, 10], bold: true };
        return obj;
      },

      //footer: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; },

      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',
      pageMargins: [50, 60, 40, 60],

      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      // pageMargins: [40, 60, 40, 60],
      // pageMargins: [ 40, 20, 20, 20 ],
      content: [
        // {
        //   // alignment: 'center', // Center the entire content
        //   // ... your existing content

        // },
      ]
    };

    var header01: any = {
      columns: [
        {
          width: '*',
          text: this.portal_main.accInfo['address'],
          bold: true,
          alignment: 'center'
        }
      ],

    }
    // dd.content.push({ text: " " });
    dd.content.push(header01)
    dd.content.push({ text: " " });
    this.arr2 = []
    var sections = Object.keys(billObj);
    var count = 0;
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];

      var sectionText: any = { text: 'Section : ' + sections[i], fontSize: 8 };
      if (i != 0) {
        sectionText['pageBreak'] = 'before'
      }
      //dd.content.push(sectionText);
      let list = ['Emp\nDetail'];
      let data_keys: any = [];
      let width = ['auto'];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
          width.push('auto')
        }
      }
      list.push('Total');
      data_keys.push('gross_pay');

      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])

          width.push('auto')
        }
      }
      list.push('total');
      data_keys.push('total');
      width.push('auto');
      list.push('Net.\nSal.');
      width.push('auto');
      data_keys.push('net');


      var tbl: any = {

        // layout: 'lightHorizontalLines',
        fontSize: 10,


        table: {
          // id: 'myTable',
          alignment: 'center', // Center the entire content
          headerRows: 1,
          // widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
          widths: [],
          margin: [10, 10],
          body: [
            // ['Emp\nDetail', 'Basic\nPay', 'Dep.\nAllow', 'DA/Relief', 'Med\nAllow', 'Veh\nAllow', 'HRA', 'WA', 'Misc\nAllow', 'Total', 'LIC', 'PF\nDed', 'NPS', 'Group\nIns.', 'IT', 'House\nRent', 'Veh\nDed', 'Veh\nAdv.', 'Bld\nAdv.', 'PF\nAdv.', 'Bank\nAdv.', 'EWF', 'Misc\nDed', 'Net.\nSal.']
            // list
            []
          ],
          // pageMargins: [40, 60, 40, 60],
        }
      };
      // for (let i = 0; i < list.length; i++) {
      //   tbl.table.body[0].push(list[i]);
      //   tbl.table.widths.push('auto')
      // }
      // dd.content.push(tbl);
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      //var total_arr = [];
      var total_obj: any = new Object();
      total_obj['emp_info'] = 'Total'
      // total_arr.push('Total')
      for (var j = 0; j < emps.length; j++) {
        var obj: any = data['data'][emps[j]];
        // var arr :any = [];
        // var str:any = obj['emp_id'] + "\n" + obj['emp_name']
        // // var str:any = obj['emp_id'] + "\n" + obj['emp_name'] + "\n" + obj['designation_code'] + "\n" + obj['grade_pay_code'] + "\n" + obj['pay_band'] + "\n" + "SAL A/C - " + obj['sal_acc'];
        // // if (obj['pf'] != undefined && obj['pf'] != null && obj['pf'] != 0) {
        // //   str += "\n" + "PF A/C - " + obj['pf']
        // // }
        // // if (obj['pf_ifsc'] != undefined && obj['pf_ifsc'] != null && obj['pf_ifsc'] != 0) {
        // //   str += "\n" + "PF Ifsc - " + obj['pf_ifsc']
        // // }
        // arr.push(str);
        for (let x = 0; x < data_keys.length; x++) {
          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = Number((obj[data_keys[x]]).toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + Number((obj[data_keys[x]]).toFixed(0))
          }
        }

      }

      const filteredData: { [key: string]: number } = {};

      for (const key in total_obj) {
        if (total_obj[key] !== 0) {
          filteredData[key] = total_obj[key];
        }
        else {
          this.arr2.push(key)
        }
      }
      const filteredList: any = list.filter((x: any, colIndex: any) => !this.arr2.includes(x));

      for (let i = 0; i < filteredList.length; i++) {
        tbl.table.body[0].push(filteredList[i]);
        tbl.table.widths.push('auto')
      }

      dd.content.push(tbl);
      data_keys = this.findMatchingValues(data_keys, filteredData);
      // this.arr1 = this.findMatchingValues1(data_keys, filteredData);

      for (var k = 0; k < emps.length; k++) {

        var obj1 = data['data'][emps[k]];
        var arr: any = [];
        var str: any = obj1['emp_id'] + "\n" + obj1['emp_name']

        arr.push(str);
        for (const key in filteredData) {
          // if (total_obj[key] !== 0) {
          if (obj1[key] != undefined && key != 'emp_name') {
            arr.push(Number(obj1[key]).toFixed(0));
          }

          // }
        }
        dd.content[dd.content.length - 1].table.body.push(arr);

      }

      dd.content[dd.content.length - 1].table.body.push(Object.values(filteredData));



    }

    dd.content.push("\n\n");
    var sign1: any = {
      columns: [
        {
          width: '*',
          text: 'PREPARED BY:',
          bold: true
        },

        {
          width: '*',
          text: 'CHECKED BY:',
          bold: true
        },
        {
          width: '*',
          text: 'SIGNED BY:',
          bold: true
        }


      ],

    }
    dd.content.push("\n\n\n");
    dd.content.push(sign1);
    dd.content.push("\n\n");
    dd.content.push({ text: "CERTIFIED:", bold: true })
    dd.content.push("\n\n");
    dd.content.push({ text: "1. That I have satisfied myself that all the salaries included in the bills drawn in the month of " + this.monthObj[month] + "/" + fin_year + " [the last preceding month] with the exception of those detailed below of which total has been refunded by deduction from the bill has been distributed to the proper persons and their receipts have been taken in acquittance rolls field in my office with reciept-stamp dully cancelled for every payment in access of Rs. 20 and that all leaves and promotions etc have been in the service book of the official concerned." })
    dd.content.push("\n");
    dd.content.push({ text: "2. That all persons for whom pay has been drawn in this bill have actually been entertained during the month." })
    dd.content.push("\n");

    dd.content.push({ text: "3. That all the persons for whom house-rent allowance has been shown in this bill actually occupied a rented house for which they paid rent as shown in this bill and are entitled to the allowance under the standing instructions." })
    dd.content.push("\n");

    dd.content.push({ text: "4. That all the persons in respect of whom conveyance allowance has been drawn in the bill have satisfied me that they have actually maintained the conveyance in a workable condition and have been using them." })
    dd.content.push("\n");

    dd.content.push({ text: "5. That the bill has been checked with the sanctioned in the scale register." })
    dd.content.push("\n");

    dd.content.push({ text: "Date :                                                    Signature Of Drawing Officer:" })
    dd.content.push("\n");

    dd.content.push({ text: "Pay Rs. ....................................." })

    if (type == 'Task_Sal_Pdf') {
      // Create PDF
      const pdfDoc = pdfMake.createPdf(dd);

      // Open PDF in a new tab
      pdfDoc.open();
    }
    else {
      pdfMake.createPdf(dd).download(file_name);
    }


  }


  print(billObj: any, header: any, month: any, fin_year: any) {
    var file_name = header['bill_desc'];
    //var txt = "VARANASASI DEVELOPMENT AUTHORITY(VDA)   Officers/THIRD/FOURTH Category EMPLOYEES STATEMENT FOR THE MONTH OF June,2020   PIRNT DATE: 2020-10-10"
    var txt = this.mainService.accInfo['account_name'] + "(" + this.mainService.accInfo['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];
    var dd: any = {
      pageSize: 'A2',
      header: function (currentPage: any, pageCount: any) {
        var obj: any = { text: txt + "     Page No. - " + currentPage, alignment: 'center', margin: [72, 40] };
        return obj;
      },

      //footer: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; },

      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',

      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [40, 60, 40, 60],
      //pageMargins: [ 40, 20, 20, 20 ],
      content: [

      ]
    };

    var header01 = {
      columns: [
        {
          width: '*',
          text: this.mainService.accInfo['address'],
          bold: true,
          alignment: 'center'
        }
      ],

    }
    dd.content.push({ text: " " });
    dd.content.push(header01)
    dd.content.push({ text: " " });
    var sections = Object.keys(billObj);
    var count = 0;
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];

      var sectionText: any = { text: 'Section : ' + sections[i], fontSize: 8 };
      if (i != 0) {
        sectionText['pageBreak'] = 'before'
      }
      let list = ['Emp\nDetail'];
      let data_keys = [];
      let width = ['auto'];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
          width.push('auto')
        }
      }
      list.push('Total');
      data_keys.push('gross_pay');

      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])

          width.push('auto')
        }
      }
      list.push('Total Ded');
      data_keys.push('total');
      width.push('auto');
      list.push('Net.\nSal.');
      width.push('auto');
      data_keys.push('net');


      var tbl: any = {
        fontSize: 10,
        table: {
          headerRows: 1,
          widths: [],
          body: [
            []
          ]
        }
      };
      for (let i = 0; i < list.length; i++) {
        tbl.table.body[0].push(list[i]);
        tbl.table.widths.push('auto')
      }
      dd.content.push(tbl);
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      var total_obj: any = new Object();
      total_obj['emp_info'] = 'Total'
      // let total_arr = [];
      //     total_arr.push('Total')
      for (var j = 0; j < emps.length; j++) {
        var obj: any = data['data'][emps[j]];
        var arr: any = [];
        var str: any = obj['emp_id'] + "\n" + obj['emp_name']
        arr.push(str);
        for (let x = 0; x < data_keys.length; x++) {
          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = Number((obj[data_keys[x]]).toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + Number((obj[data_keys[x]]).toFixed(0))
          }
          //deepankar
          //total_arr.push((obj[data_keys[x]]).toFixed(0))
          //deepankar
          arr.push(Number(obj[data_keys[x]].toFixed(0)))
        }


        dd.content[dd.content.length - 1].table.body.push(arr);
      }
      dd.content[dd.content.length - 1].table.body.push(Object.values(total_obj));



    }
    dd.content.push("\n\n");
    var sign1: any = {
      columns: [
        {
          width: '*',
          text: 'PREPARED BY:',
          bold: true
        },

        {
          width: '*',
          text: 'CHECKED BY:',
          bold: true
        },
        {
          width: '*',
          text: 'SIGNED BY:',
          bold: true
        }


      ],

    }
    dd.content.push("\n\n\n");
    dd.content.push(sign1);
    dd.content.push("\n\n");
    dd.content.push({ text: "CERTIFIED:", bold: true })
    dd.content.push("\n\n");
    dd.content.push({ text: "1. That I have satisfied myself that all the salaries included in the bills drawn in the month of " + this.monthObj[month] + "/" + fin_year + " [the last preceding month] with the exception of those detailed below of which total has been refunded by deduction from the bill has been distributed to the proper persons and their receipts have been taken in acquittance rolls field in my office with reciept-stamp dully cancelled for every payment in access of Rs. 20 and that all leaves and promotions etc have been in the service book of the official concerned." })
    dd.content.push("\n");
    dd.content.push({ text: "2. That all persons for whom pay has been drawn in this bill have actually been entertained during the month." })
    dd.content.push("\n");

    dd.content.push({ text: "3. That all the persons for whom house-rent allowance has been shown in this bill actually occupied a rented house for which they paid rent as shown in this bill and are entitled to the allowance under the standing instructions." })
    dd.content.push("\n");

    dd.content.push({ text: "4. That all the persons in respect of whom conveyance allowance has been drawn in the bill have satisfied me that they have actually maintained the conveyance in a workable condition and have been using them." })
    dd.content.push("\n");

    dd.content.push({ text: "5. That the bill has been checked with the sanctioned in the scale register." })
    dd.content.push("\n");

    dd.content.push({ text: "Date :                                                    Signature Of Drawing Officer:" })
    dd.content.push("\n");

    dd.content.push({ text: "Pay Rs. ....................................." })




    pdfMake.createPdf(dd).download(file_name);
  }


  // exportExcel2(billObj:any, header:any, erpUser:any) {

  //   var sections = Object.keys(billObj);
  //   if (sections.length === 0) {
  //     Swal.fire('INFO', 'No Data Found', 'info');
  //     return;
  //   }

  //   this.spinner.show();

  //   let data_to_print :any= []
  //   let list:any = []
  //   var count = 0;
  //   for (var i = 0; i < sections.length; i++) {
  //     var data = billObj[sections[i]];
  //     // list = ['Emp\nDetail'];
  //     list = ['SI NO'];

  //     list.push('Emp Id')
  //     list.push('Emp Name')
  //     list.push('Month')
  //     list.push('Designation')
  //     list.push('Section Code')
  //     // ['Emp\nName'];
  //     let data_keys = [];
  //     for (let i = 0; i < this.all_component.length; i++) {
  //       if (this.all_component[i]['pay_code'] == 'PAY') {
  //         list.push(this.all_component[i]['component_code'])
  //         data_keys.push(this.all_component[i]['component_code'])
  //       }
  //     }
  //     list.push('Total');
  //     data_keys.push('gross_pay');

  //     for (let i = 0; i < this.all_component.length; i++) {
  //       if (this.all_component[i]['pay_code'] == 'DED') {
  //         list.push(this.all_component[i]['component_code']);
  //         data_keys.push(this.all_component[i]['component_code'])
  //       }
  //     }
  //     list.push('Total Ded');
  //     data_keys.push('total');
  //     list.push('Net.\nSal.');
  //     data_keys.push('net');
  //     var emps = Object.keys(data['data']);
  //     count = count + emps.length;

  //     var total_obj :any= new Object();
  //     total_obj['si_no'] = 'Total'
  //     total_obj['emp_info'] = ''
  //     total_obj['emp_name'] = ''
  //     total_obj['month'] = ''
  //     total_obj['designation'] = ''
  //     total_obj['Section_code'] = ''

  //     let objsall :any= {}
  //     let temp :any= {}

  //     for (var j = 0; j < emps.length; j++) {
  //       var obj :any = data['data'][emps[j]];
  //       var arr :any = [];

  //       // var str:any = obj['emp_id'] + "\n" + obj['emp_name']
  //       var str:any = obj['emp_id']
  //       var str1:any =obj['emp_name']

  //       arr.push(j + 1)
  //       arr.push(str);
  //       arr.push(str1);
  //       arr.push(this.monthObj[obj['month']]);
  //       arr.push(obj['designation_code'])
  //       arr.push(obj['leaf_value'])

  //       for (let x = 0; x < data_keys.length; x++) {

  //         if (total_obj[data_keys[x]] == undefined) {
  //           total_obj[data_keys[x]] = parseInt((obj[data_keys[x]]).toFixed(0))
  //         } else {
  //           total_obj[data_keys[x]] = total_obj[data_keys[x]] + parseInt((obj[data_keys[x]]).toFixed(0))
  //         }
  //         arr.push((obj[data_keys[x]]).toFixed(0))
  //         temp['si_no'] = ''
  //         temp['emp_name'] = ''
  //         temp['month'] = ''
  //         temp['designation'] = ''
  //         temp['Section_code'] = 'TOTAL SUM'
  //         temp['emp_info'] = ''
  //         temp[data_keys[x]] = Number(Math.round(obj[data_keys[x]]).toFixed(0))
  //       }




  //       if (objsall[obj['emp_id']] == undefined) {
  //         objsall[obj['emp_id']] = {}
  //         // +'-'+data_keys[x]]={}
  //         objsall[obj['emp_id']] = Object.assign({}, temp)
  //       } else {
  //         for (let x = 0; x < data_keys.length; x++) {
  //           // objsall[obj['emp_id']][data_keys[x]]=0
  //           objsall[obj['emp_id']][data_keys[x]] = objsall[obj['emp_id']][data_keys[x]] + Number(Math.round((obj[data_keys[x]]).toFixed(0)))


  //         }


  //       }
  //       data_to_print.push(arr)




  //       if (j != emps.length - 1 && emps[j].split('-')[0] == emps[j + 1].split('-')[0]) {


  //       } else {

  //         data_to_print.push(Object.values(objsall[obj['emp_id']]))






  //       }


  //     }
  //     data_to_print.push(Object.values(total_obj))
  //   }

  //   const workbook = new Workbook();
  //   const worksheet = workbook.addWorksheet('arrear_bill');


  //   var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];

  //   //Add Row and formatting
  //   let titleRow = worksheet.addRow([title]);
  //   titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
  //   titleRow.font = { size: 14, bold: true }


  //   worksheet.mergeCells('A1:AL2');
  //   worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };

  //   // let header_arr = ['Emp Detail', 'BASIC', 'CCA', 'Comp Alw', 'CONV', 'DA', 'DEP-ALLOW', 'HRA', 'HVDT Allow', 'MED', 'Per Pay',
  //   //   'Res Alw', 'WA', 'Handicapped Allowance', 'PR BHATTA', 'Washing Allowance', 'Total', 'Comp-Loan', 'Cons-Loan', 'CPF/GPF Ded', 'Fest Adv',
  //   //   'GIS', 'H. RENT', 'HB Adv', 'HDFC', 'L Tax', 'Misc Ded', 'NPS', 'Other Adv', 'Other Ded', 'PF', 'PF Advance', 'Veh Loan', 'WF', 'E.P.F',
  //   //   'IT', 'Total Ded', 'Net.Sal'

  //   // ]

  //   const rowIndex:any = 3;
  //   list.map((x:any, colIndex:any) => {
  //     worksheet.getCell(rowIndex, colIndex + 1).value = x;
  //     worksheet.getCell(rowIndex, colIndex + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
  //     worksheet.getCell(rowIndex, colIndex + 1).alignment = { vertical: 'distributed', horizontal: 'center' };
  //     worksheet.getCell(rowIndex, colIndex + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  //     worksheet.getCell(rowIndex, colIndex + 1).font = { size: 10, bold: true }
  //   })



  //   //inserting data
  //   data_to_print.forEach((d:any, i:any) => {
  //     let row = worksheet.addRow(d);
  //     row.alignment = { vertical: 'distributed', horizontal: 'center' }
  //     if (i === data_to_print.length - 1) {
  //       row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
  //       row.alignment = { vertical: 'distributed', horizontal: 'center' };
  //       row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  //       row.font = { size: 12, bold: true }

  //     }
  //   });

  //   this.spinner.hide();
  //   //  save excel file
  //   workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
  //     const blob = new Blob([data]);
  //     fs.saveAs(blob, 'Arrear_Bill.xlsx')
  //   })
  // }
  // arr1 = []



  exportExcel2(billObj: any, header: any, erpUser: any) {

    var sections = Object.keys(billObj);
    if (sections.length === 0) {
      Swal.fire('INFO', 'No Data Found', 'info');
      return;
    }

    this.spinner.show();
    let flag = true;
    let data_to_print: any = []
    let list: any = []
    var count = 0;
    let data_keys: any = [];
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];
      // list = ['Emp\nDetail'];
      list = ['SI NO'];

      list.push('Emp Id')
      list.push('Emp Name')
      list.push('Month')
      list.push('Designation')
      list.push('Section Code')
      // ['Emp\nName'];
      data_keys = [];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      list.push('Total');
      data_keys.push('gross_pay');

      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      // list.push('Total Ded');
      // data_keys.push('total');
      list.push('total');
      data_keys.push('total');
      list.push('Net.\nSal.');
      data_keys.push('net');
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      var total_obj: any = new Object();
      total_obj['si_no'] = 'Total'
      total_obj['emp_info'] = ''
      total_obj['emp_name'] = ''
      total_obj['month'] = ''
      total_obj['designation'] = ''
      total_obj['Section_code'] = ''

      let objsall: any = {}
      let temp: any = {}

      for (var j = 0; j < emps.length; j++) {
        var obj: any = data['data'][emps[j]];
        var arr: any = [];

        // var str:any = obj['emp_id'] + "\n" + obj['emp_name']
        var str: any = obj['emp_id']
        var str1: any = obj['emp_name']

        // arr.push(j + 1)
        // arr.push(str);
        // arr.push(str1);
        // arr.push(this.monthObj[obj['month']]);
        // arr.push(obj['designation_code'])
        // arr.push(obj['leaf_value'])

        for (let x = 0; x < data_keys.length; x++) {

          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = Number((obj[data_keys[x]]).toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + Number((obj[data_keys[x]]).toFixed(0))
          }
          // arr.push((obj[data_keys[x]]).toFixed(0))

          // temp[data_keys[x]] = Number(Math.round(obj[data_keys[x]]).toFixed(0))
        }




        if (j != emps.length - 1 && emps[j].split('-')[0] == emps[j + 1].split('-')[0]) {


        } else {

          // data_to_print.push(Object.values(objsall[obj['emp_id']]))






        }


      }
      // data_to_print.push(Object.values(total_obj))

      const filteredData: { [key: string]: number } = {};

      for (const key in total_obj) {
        if (total_obj[key] !== 0) {
          filteredData[key] = total_obj[key];
        }
        else {
          this.arr1.push(key)
        }
      }
      data_keys = this.findMatchingValues(data_keys, filteredData);
      // this.arr1 = this.findMatchingValues1(data_keys, filteredData);


      for (var j = 0; j < emps.length; j++) {
        var obj: any = data['data'][emps[j]];
        var arr: any = [];
        // if (flag) {
        //   // arr.push(count)

        //   var str:any = obj['emp_id']
        //   var str1:any =obj['emp_name']

        // arr.push(j + 1)
        // arr.push(str);
        // arr.push(str1);
        // arr.push(this.monthObj[obj['month']]);
        // arr.push(obj['designation_code'])
        // arr.push(obj['leaf_value'])

        //   flag = false;
        // } else {
        //   arr.push('')
        //   arr.push('')
        //   arr.push('')
        //   arr.push('')
        //   arr.push('')
        //   arr.push('')
        // }
        var str: any = obj['emp_id']
        var str1: any = obj['emp_name']

        arr.push(j + 1)
        arr.push(str);
        arr.push(str1);
        arr.push(this.monthObj[obj['month']]);
        arr.push(obj['designation_code'])
        arr.push(obj['leaf_value'])

        for (const key in filteredData) {


          if (typeof obj[key] == 'number') {
            arr.push(Number(obj[key]).toFixed(0))
          }

          if (key == 'si_no' || key == 'emp_name' || key == 'month' || key == 'designation' || key == 'Section_code' || key == 'emp_info') {
            temp['si_no'] = ''
            temp['emp_name'] = ''
            temp['month'] = ''
            temp['designation'] = ''
            temp['Section_code'] = 'TOTAL SUM'
            temp['emp_info'] = ''
          }
          else {
            temp[key] = Number(obj[key].toFixed(0))
          }
          // temp['emp_info'] = ''
          // if(temp[key]!=undefined){

          //   }
          //  else{
          //   temp[key]=''
          //  }
        }




        if (objsall[obj['emp_id']] == undefined) {
          objsall[obj['emp_id']] = {}
          // +'-'+data_keys[x]]={}
          objsall[obj['emp_id']] = Object.assign({}, temp)
        } else {
          for (const key in filteredData) {
            if (key == 'si_no' || key == 'emp_name' || key == 'month' || key == 'designation' || key == 'Section_code' || key == 'emp_info') {
              temp['si_no'] = ''
              temp['emp_name'] = ''
              temp['month'] = ''
              temp['designation'] = ''
              temp['Section_code'] = 'TOTAL SUM'
              temp['emp_info'] = ''
            } else {
              // objsall[obj['emp_id']][key]=0
              objsall[obj['emp_id']][key] = objsall[obj['emp_id']][key] + Number((obj[key]).toFixed(0))

            }


          }


        }
        data_to_print.push(arr)




        if (j != emps.length - 1 && emps[j].split('-')[0] == emps[j + 1].split('-')[0]) {


        } else {

          data_to_print.push(Object.values(objsall[obj['emp_id']]))






        }


      }
      data_to_print.push(Object.values(filteredData))

    }



    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('arrear_bill');


    var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
    titleRow.font = { size: 14, bold: true }


    worksheet.mergeCells('A1:M2');
    worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };

    const filteredList: any = list.filter((x: any, colIndex: any) => !this.arr1.includes(x));

    const rowIndex: any = 3;
    filteredList.map((x: any, colIndex: any) => {
      if (!(this.arr1.includes(x))) {
        worksheet.getCell(rowIndex, colIndex + 1).value = x;
        worksheet.getCell(rowIndex, colIndex + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
        worksheet.getCell(rowIndex, colIndex + 1).alignment = { vertical: 'distributed', horizontal: 'center' };
        worksheet.getCell(rowIndex, colIndex + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell(rowIndex, colIndex + 1).font = { size: 10, bold: true }
      }

    })



    //inserting data
    data_to_print.forEach((d: any, i: any) => {
      let row = worksheet.addRow(d);
      row.alignment = { vertical: 'distributed', horizontal: 'center' }
      if (i === data_to_print.length - 1) {
        row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
        row.alignment = { vertical: 'distributed', horizontal: 'center' };
        row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        row.font = { size: 12, bold: true }

      }
    });

    this.spinner.hide();
    //  save excel file
    workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
      const blob = new Blob([data]);
      fs.saveAs(blob, 'Arrear_Bill.xlsx')
    })
  }
  arr1: any = []









  formatingdtaForPopup(billObj: any) {


    this.arr1 = []
    var sections = Object.keys(billObj);
    if (sections.length === 0) {
      Swal.fire('INFO', 'No Data Found', 'info');
      return;
    }

    this.spinner.show();

    let data_to_print: any = []
    let list: any = []
    var count = 0;
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];
      // list = ['Emp\nDetail'];
      list = ['SI NO'];
      list.push('Emp Id')
      list.push('Emp Name')
      list.push('Designation')
      list.push('Section Code')
      // ['Emp\nName'];
      let data_keys: any = [];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      list.push('Total');
      data_keys.push('gross_pay');

      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])
        }
      }



      list.push('Total Ded');
      data_keys.push('total');
      list.push('Net.\nSal.');
      data_keys.push('net');
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      var total_obj: any = new Object();
      total_obj['si_no'] = 'Total'
      total_obj['emp_info'] = ''
      total_obj['emp_name'] = ''
      total_obj['designation'] = ''
      total_obj['Section_code'] = ''
      for (var j = 0; j < emps.length; j++) {
        var obj: any = data['data'][emps[j]];
        // var arr :any = [];
        // // var str:any = obj['emp_id'] + "\n" + obj['emp_name']
        // var str:any = obj['emp_id']
        // var str1:any =obj['emp_name']

        // arr.push(j + 1)
        // arr.push(str);
        // arr.push(str1);
        // arr.push(obj['designation_code'])
        // arr.push(obj['leaf_value'])
        for (let x = 0; x < data_keys.length; x++) {
          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = Number(obj[data_keys[x]].toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + Number(obj[data_keys[x]].toFixed(0))
          }

          // arr.push((obj[data_keys[x]]).toFixed(0))
        }

        // data_to_print.push(arr)
      }

      const filteredData: { [key: string]: number } = {};

      for (const key in total_obj) {
        if (total_obj[key] !== 0) {
          filteredData[key] = total_obj[key];
        }

        else {
          this.arr1.push(key)
        }
      }

      // for (const key in filteredData) {
      //   if (filteredData[key] !== 0) {
      //     filteredData[key] = total_obj[key];
      //   }
      //   // if (key == "gross_pay" || key == "net") {
      //     // filteredData[key] = Number(total_obj[key].toFixed(0));
      //   // }
      //   // else {
      //   //   if (typeof (total_obj[key]) === "number") {
      //   //     filteredData[key] = Number(total_obj[key].toFixed(0))
      //   //   }
      //   // }


      // }





      data_keys = this.findMatchingValues(data_keys, filteredData);
      // this.arr1 = this.findMatchingValues1(data_keys, filteredData);

    }














  }










  print1(billObj: any, header: any, month: any, fin_year: any, showobj: any, type: any) {

    var file_name

    if (showobj['bill_desc'] == undefined) {
      file_name = header['bill_desc'];

    }
    else {
      file_name = showobj['bill_desc'];

    }
    //var txt = "VARANASASI DEVELOPMENT AUTHORITY(VDA)   Officers/THIRD/FOURTH Category EMPLOYEES STATEMENT FOR THE MONTH OF June,2020   PIRNT DATE: 2020-10-10"
    var txt = this.mainService.accInfo['account_name'] + "(" + this.mainService.accInfo['account_short_name'] + ")" + "   " + file_name + "   Date: " + header['accrual_date'];
    var dd: any = {
      pageSize: 'A3',
      header: function (currentPage: any, pageCount: any) {
        var obj: any = { text: txt + "     Page No. - " + currentPage, alignment: 'center', margin: [10, 10], bold: true };
        return obj;
      },

      //footer: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; },

      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',
      pageMargins: [50, 60, 40, 60],

      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      // pageMargins: [40, 60, 40, 60],
      // pageMargins: [ 40, 20, 20, 20 ],
      content: [
        // {
        //   // alignment: 'center', // Center the entire content
        //   // ... your existing content

        // },
      ]
    };

    var header01 = {
      columns: [
        {
          width: '*',
          text: this.mainService.accInfo['address'],
          bold: true,
          alignment: 'center'
        }
      ],

    }
    // dd.content.push({ text: " " });
    dd.content.push(header01)
    dd.content.push({ text: " " });
    this.arr2 = []
    var sections = Object.keys(billObj);
    var count = 0;
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];

      var sectionText: any = { text: 'Section : ' + sections[i], fontSize: 8 };
      if (i != 0) {
        sectionText['pageBreak'] = 'before'
      }
      //dd.content.push(sectionText);
      let list = ['Emp\nDetail'];
      let data_keys: any = [];
      let width = ['auto'];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
          width.push('auto')
        }
      }
      list.push('Total');

      data_keys.push('gross_pay');
      // width.push('auto')
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])

          width.push('auto')
        }
      }
      list.push('total');
      data_keys.push('total');
      width.push('auto');
      list.push('Net.\nSal.');
      width.push('auto');
      data_keys.push('net');


      var tbl: any = {

        // layout: 'lightHorizontalLines',
        fontSize: 10,


        table: {
          // id: 'myTable',
          alignment: 'center', // Center the entire content
          headerRows: 1,
          // widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
          widths: [],
          margin: [10, 10],
          body: [
            // ['Emp\nDetail', 'Basic\nPay', 'Dep.\nAllow', 'DA/Relief', 'Med\nAllow', 'Veh\nAllow', 'HRA', 'WA', 'Misc\nAllow', 'Total', 'LIC', 'PF\nDed', 'NPS', 'Group\nIns.', 'IT', 'House\nRent', 'Veh\nDed', 'Veh\nAdv.', 'Bld\nAdv.', 'PF\nAdv.', 'Bank\nAdv.', 'EWF', 'Misc\nDed', 'Net.\nSal.']
            // list
            []
          ],
          // pageMargins: [40, 60, 40, 60],
        }
      };
      // for (let i = 0; i < list.length; i++) {
      //   tbl.table.body[0].push(list[i]);
      //   tbl.table.widths.push('auto')
      // }
      // dd.content.push(tbl);
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      //var total_arr = [];
      var total_obj: any = new Object();
      total_obj['emp_info'] = 'Total'
      // total_arr.push('Total')
      for (var j = 0; j < emps.length; j++) {
        var obj: any = data['data'][emps[j]];
        // var arr :any = [];
        // var str:any = obj['emp_id'] + "\n" + obj['emp_name']
        // // var str:any = obj['emp_id'] + "\n" + obj['emp_name'] + "\n" + obj['designation_code'] + "\n" + obj['grade_pay_code'] + "\n" + obj['pay_band'] + "\n" + "SAL A/C - " + obj['sal_acc'];
        // // if (obj['pf'] != undefined && obj['pf'] != null && obj['pf'] != 0) {
        // //   str += "\n" + "PF A/C - " + obj['pf']
        // // }
        // // if (obj['pf_ifsc'] != undefined && obj['pf_ifsc'] != null && obj['pf_ifsc'] != 0) {
        // //   str += "\n" + "PF Ifsc - " + obj['pf_ifsc']
        // // }
        // arr.push(str);
        for (let x = 0; x < data_keys.length; x++) {
          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = Number((obj[data_keys[x]]).toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + Number((obj[data_keys[x]]).toFixed(0))
          }
        }

      }

      const filteredData: { [key: string]: number } = {};

      for (const key in total_obj) {
        if (total_obj[key] !== 0) {
          filteredData[key] = total_obj[key];
        }
        else {
          this.arr2.push(key)
        }
      }
      const filteredList: any = list.filter((x: any, colIndex: any) => !this.arr2.includes(x));

      for (let i = 0; i < filteredList.length; i++) {
        tbl.table.body[0].push(filteredList[i]);
        tbl.table.widths.push('auto')
      }

      dd.content.push(tbl);
      data_keys = this.findMatchingValues(data_keys, filteredData);
      // this.arr1 = this.findMatchingValues1(data_keys, filteredData);

      for (var k = 0; k < emps.length; k++) {

        var obj1 = data['data'][emps[k]];
        var arr: any = [];
        var str: any = obj1['emp_id'] + "\n" + obj1['emp_name']

        arr.push(str);
        for (const key in filteredData) {
          // if (total_obj[key] !== 0) {
          if (obj1[key] != undefined && key != 'emp_name') {
            arr.push(Number(obj1[key]).toFixed(0));
          }

          // }
        }
        dd.content[dd.content.length - 1].table.body.push(arr);

      }

      dd.content[dd.content.length - 1].table.body.push(Object.values(filteredData));



    }

    dd.content.push("\n\n");
    var sign1: any = {
      columns: [
        {
          width: '*',
          text: 'PREPARED BY:',
          bold: true
        },

        {
          width: '*',
          text: 'CHECKED BY:',
          bold: true
        },
        {
          width: '*',
          text: 'SIGNED BY:',
          bold: true
        }


      ],

    }
    dd.content.push("\n\n\n");
    dd.content.push(sign1);
    dd.content.push("\n\n");
    dd.content.push({ text: "CERTIFIED:", bold: true })
    dd.content.push("\n\n");
    dd.content.push({ text: "1. That I have satisfied myself that all the salaries included in the bills drawn in the month of " + this.monthObj[month] + "/" + fin_year + " [the last preceding month] with the exception of those detailed below of which total has been refunded by deduction from the bill has been distributed to the proper persons and their receipts have been taken in acquittance rolls field in my office with reciept-stamp dully cancelled for every payment in access of Rs. 20 and that all leaves and promotions etc have been in the service book of the official concerned." })
    dd.content.push("\n");
    dd.content.push({ text: "2. That all persons for whom pay has been drawn in this bill have actually been entertained during the month." })
    dd.content.push("\n");

    dd.content.push({ text: "3. That all the persons for whom house-rent allowance has been shown in this bill actually occupied a rented house for which they paid rent as shown in this bill and are entitled to the allowance under the standing instructions." })
    dd.content.push("\n");

    dd.content.push({ text: "4. That all the persons in respect of whom conveyance allowance has been drawn in the bill have satisfied me that they have actually maintained the conveyance in a workable condition and have been using them." })
    dd.content.push("\n");

    dd.content.push({ text: "5. That the bill has been checked with the sanctioned in the scale register." })
    dd.content.push("\n");

    dd.content.push({ text: "Date :                                                    Signature Of Drawing Officer:" })
    dd.content.push("\n");

    dd.content.push({ text: "Pay Rs. ....................................." })


    pdfMake.createPdf(dd).download(file_name);



  }

  datatoPopup: any;
  currentmonth_userdata: any;
  exportExcel1(billObj: any, header: any, erpUser: any, type: any) {
    this.arr1 = []
    // this.currentmonth_userdata=''
    // this.currentmonth_userdata =billObj
    let datatoreturn;
    var sections = Object.keys(billObj);
    if (sections.length === 0) {
      Swal.fire('INFO', 'No Data Found', 'info');
      return;
    }

    this.spinner.show();

    let data_to_print: any = []
    let list: any = []
    var count = 0;
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];
      this.currentmonth_userdata = Object.values(data)

      // list = ['Emp\nDetail'];
      list = ['SI NO'];
      list.push('Emp Id')
      list.push('Emp Name')
      list.push('Designation')
      list.push('Section Code')
      // ['Emp\nName'];
      let data_keys: any = [];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      list.push('Total');
      data_keys.push('gross_pay');

      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])
        }
      }



      list.push('Total Ded');
      data_keys.push('total');
      list.push('Net.\nSal.');
      data_keys.push('net');
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      var total_obj: any = new Object();
      total_obj['si_no'] = 'Total'
      total_obj['emp_info'] = ''
      total_obj['emp_name'] = ''
      total_obj['designation'] = ''
      total_obj['Section_code'] = ''
      for (var j = 0; j < emps.length; j++) {
        var obj: any = data['data'][emps[j]];

        for (let x = 0; x < data_keys.length; x++) {
          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = Number(obj[data_keys[x]].toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + Number(obj[data_keys[x]].toFixed(0))
          }

        }


      }

      const filteredData: { [key: string]: number } = {};

      for (const key in total_obj) {
        if (total_obj[key] !== 0) {
          filteredData[key] = total_obj[key];
        }

        else {
          this.arr1.push(key)
        }
      }






      data_keys = this.findMatchingValues(data_keys, filteredData);
      // this.arr1 = this.findMatchingValues1(data_keys, filteredData);
      datatoreturn = data_keys
      for (var k = 0; k < emps.length; k++) {

        var obj1 = data['data'][emps[k]];
        var arr: any = [];
        // var str:any = obj['emp_id'] + "\n" + obj['emp_name']
        var str: any = obj1['emp_id']
        var str1: any = obj1['emp_name']

        arr.push(k + 1)
        arr.push(str);
        arr.push(str1);
        arr.push(obj1['designation_code'])
        arr.push(obj1['leaf_value'])
        for (const key in filteredData) {
          if (obj1[key] != undefined && key != 'emp_name') {
            arr.push(Number(obj1[key].toFixed(0)));
          }
        }
        data_to_print.push(arr)
      }
      data_to_print.push(Object.values(filteredData))
    }

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('salary_bill');

    if (data['district'] != undefined) {
      // var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")" + erpUser['address'] + "   " + header['bill_desc'] + "(" + data['district'] + " )   Date: " + header['accrual_date'];

      var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")"

      var title1 = erpUser['address']

      var title2 = header['bill_desc'] + "   Date: " + header['accrual_date'];

    }
    else {
      var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")"

      var title1 = erpUser['address']

      var title2 = header['bill_desc'] + "   Date: " + header['accrual_date'];

    }
    // Add Row and formatting for titleRow
    let titleRow = worksheet.addRow([title]);
    titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
    titleRow.font = { size: 14, bold: true }

    // Add Row and formatting for titleRow1
    let titleRow1 = worksheet.addRow([title1]);
    titleRow1.alignment = { vertical: 'distributed', horizontal: 'center' };
    titleRow1.font = { size: 14, bold: true }

    // Add Row and formatting for titleRow2
    let titleRow2 = worksheet.addRow([title2]);
    titleRow2.alignment = { vertical: 'distributed', horizontal: 'center' };
    titleRow2.font = { size: 14, bold: true }

    // Merge cells for titleRow
    worksheet.mergeCells('A1:T1');

    // Merge cells for titleRow1
    worksheet.mergeCells('A2:T2');

    // Merge cells for titleRow2
    worksheet.mergeCells('A3:T3');

    // Set border for the merged cells
    worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };
    worksheet.getCell('A2').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };
    worksheet.getCell('A3').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };


    // //Add Row and formatting
    // let titleRow = worksheet.addRow([title]);
    // titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
    // titleRow.font = { size: 14, bold: true }


    // worksheet.mergeCells('A2:T1');
    // worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };

    // let header_arr = ['Emp Detail', 'BASIC', 'CCA', 'Comp Alw', 'CONV', 'DA', 'DEP-ALLOW', 'HRA', 'HVDT Allow', 'MED', 'Per Pay',
    //   'Res Alw', 'WA', 'Handicapped Allowance', 'PR BHATTA', 'Washing Allowance', 'Total', 'Comp-Loan', 'Cons-Loan', 'CPF/GPF Ded', 'Fest Adv',
    //   'GIS', 'H. RENT', 'HB Adv', 'HDFC', 'L Tax', 'Misc Ded', 'NPS', 'Other Adv', 'Other Ded', 'PF', 'PF Advance', 'Veh Loan', 'WF', 'E.P.F',
    //   'IT', 'Total Ded', 'Net.Sal'

    // ]
    const filteredList: any = list.filter((x: any, colIndex: any) => !this.arr1.includes(x));

    const rowIndex: any = 4;
    filteredList.map((x: any, colIndex: any) => {
      if (!(this.arr1.includes(x))) {

        worksheet.getCell(rowIndex, colIndex + 1).value = x;
        worksheet.getCell(rowIndex, colIndex + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
        worksheet.getCell(rowIndex, colIndex + 1).alignment = { vertical: 'distributed', horizontal: 'center' };
        worksheet.getCell(rowIndex, colIndex + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getCell(rowIndex, colIndex + 1).font = { size: 10, bold: true }
      }

    })


    data_to_print.push([]);
    data_to_print.push(['PREPARED BY:'])
    data_to_print.push(['CHECKED BY:'])
    data_to_print.push(['SIGNED BY:'])

    data_to_print.push([]);

    //inserting data
    data_to_print.forEach((d: any, i: any) => {
      let row = worksheet.addRow(d);
      row.alignment = { vertical: 'distributed', horizontal: 'center' }

      if (d == 'SIGNED BY:' || d == 'CHECKED BY:' || d == 'PREPARED BY:') {
        // row.border =  { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };
        row.font = { size: 14, bold: true }
      }
      // if (i === data_to_print.length - 1) {
      //   row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
      //   row.alignment = { vertical: 'distributed', horizontal: 'center' };
      //   row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      //   row.font = { size: 12, bold: true }


      // }

    });

    if (this.popup && this.popup === "popup") {
      let obj: any = {}

      obj['dsdf'] = data_to_print;
      obj['data'] = datatoreturn;
      this.datatoPopup = datatoreturn
      this.popup = undefined;

      return obj;
    }
    this.popup = undefined;
    this.spinner.hide();
    //  save excel file
    workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
      const blob = new Blob([data]);
      fs.saveAs(blob, 'Salary_Bill.xlsx')
    })
  }


  findMatchingValues(array: any, object: any) {
    const matchingValues: any = {};

    array.forEach((key: any) => {
      if (object.hasOwnProperty(key)) {
        matchingValues[key] = object[key];
      }

    });

    return matchingValues;
  }


  findMatchingValues1(array: any, object: any) {
    const matchingValues: any = [];

    array.forEach((key: any) => {
      if (object.hasOwnProperty(key)) {
        // matchingValues[key] = object[key];
      }
      else {
        matchingValues[key] = object[key];

      }
    });

    return matchingValues;
  }

  // exportExcel1(billObj:any, header:any, erpUser:any) {

  //   var sections = Object.keys(billObj);
  //   if (sections.length === 0) {
  //     Swal.fire('INFO', 'No Data Found', 'info');
  //     return;
  //   }

  //   this.spinner.show();

  //   let data_to_print :any= []
  //   let list:any = []
  //   var count = 0;
  //   for (var i = 0; i < sections.length; i++) {
  //     var data = billObj[sections[i]];
  //     // list = ['Emp\nDetail'];
  //     list = ['SI NO'];
  //     list.push('Emp Id')
  //     list.push('Emp Name')
  //     list.push('Designation')
  //     list.push('Section Code')
  //     // ['Emp\nName'];
  //     let data_keys = [];
  //     for (let i = 0; i < this.all_component.length; i++) {
  //       if (this.all_component[i]['pay_code'] == 'PAY') {
  //         list.push(this.all_component[i]['component_code'])
  //         data_keys.push(this.all_component[i]['component_code'])
  //       }
  //     }
  //     list.push('Total');
  //     data_keys.push('gross_pay');

  //     for (let i = 0; i < this.all_component.length; i++) {
  //       if (this.all_component[i]['pay_code'] == 'DED') {
  //         list.push(this.all_component[i]['component_code']);
  //         data_keys.push(this.all_component[i]['component_code'])
  //       }
  //     }
  //     list.push('Total Ded');
  //     data_keys.push('total');
  //     list.push('Net.\nSal.');
  //     data_keys.push('net');
  //     var emps = Object.keys(data['data']);
  //     count = count + emps.length;

  //     var total_obj :any= new Object();
  //     total_obj['si_no'] = 'Total'
  //     total_obj['emp_info'] = ''
  //     total_obj['emp_name'] = ''
  //     total_obj['designation'] = ''
  //     total_obj['Section_code'] = ''
  //     for (var j = 0; j < emps.length; j++) {
  //       var obj :any = data['data'][emps[j]];
  //       var arr :any = [];
  //       // var str:any = obj['emp_id'] + "\n" + obj['emp_name']
  //       var str:any = obj['emp_id']
  //       var str1:any =obj['emp_name']

  //       arr.push(j + 1)
  //       arr.push(str);
  //       arr.push(str1);
  //       arr.push(obj['designation_code'])
  //       arr.push(obj['leaf_value'])
  //       for (let x = 0; x < data_keys.length; x++) {
  //         if (total_obj[data_keys[x]] == undefined) {
  //           total_obj[data_keys[x]] = parseInt((obj[data_keys[x]]).toFixed(0))
  //         } else {
  //           total_obj[data_keys[x]] = total_obj[data_keys[x]] + parseInt((obj[data_keys[x]]).toFixed(0))
  //         }

  //         arr.push((obj[data_keys[x]]).toFixed(0))
  //       }

  //       data_to_print.push(arr)
  //     }
  //   //   const filteredData: { [key: string]: number } = {};

  //   //   for (const key in total_obj) {
  //   //     if (total_obj[key] !== 0) {
  //   //       filteredData[key] = total_obj[key];
  //   //     }
  //   //   }
  //   //   data_to_print.push(Object.values(filteredData))
  //     data_to_print.push(Object.values(total_obj))
  //   }

  //   const workbook = new Workbook();
  //   const worksheet = workbook.addWorksheet('salary_bill');


  //   var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];

  //   //Add Row and formatting
  //   let titleRow = worksheet.addRow([title]);
  //   titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
  //   titleRow.font = { size: 14, bold: true }


  //   worksheet.mergeCells('A1:AL2');
  //   worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };

  //   // let header_arr = ['Emp Detail', 'BASIC', 'CCA', 'Comp Alw', 'CONV', 'DA', 'DEP-ALLOW', 'HRA', 'HVDT Allow', 'MED', 'Per Pay',
  //   //   'Res Alw', 'WA', 'Handicapped Allowance', 'PR BHATTA', 'Washing Allowance', 'Total', 'Comp-Loan', 'Cons-Loan', 'CPF/GPF Ded', 'Fest Adv',
  //   //   'GIS', 'H. RENT', 'HB Adv', 'HDFC', 'L Tax', 'Misc Ded', 'NPS', 'Other Adv', 'Other Ded', 'PF', 'PF Advance', 'Veh Loan', 'WF', 'E.P.F',
  //   //   'IT', 'Total Ded', 'Net.Sal'

  //   // ]

  //   const rowIndex:any = 3;
  //   list.map((x:any, colIndex:any) => {
  //     worksheet.getCell(rowIndex, colIndex + 1).value = x;
  //     worksheet.getCell(rowIndex, colIndex + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
  //     worksheet.getCell(rowIndex, colIndex + 1).alignment = { vertical: 'distributed', horizontal: 'center' };
  //     worksheet.getCell(rowIndex, colIndex + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  //     worksheet.getCell(rowIndex, colIndex + 1).font = { size: 10, bold: true }
  //   })



  //   //inserting data
  //   data_to_print.forEach((d:any, i:any) => {
  //     let row = worksheet.addRow(d);
  //     row.alignment = { vertical: 'distributed', horizontal: 'center' }
  //     if (i === data_to_print.length - 1) {
  //       row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
  //       row.alignment = { vertical: 'distributed', horizontal: 'center' };
  //       row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  //       row.font = { size: 12, bold: true }

  //     }
  //   });

  //   this.spinner.hide();
  //   //  save excel file
  //   workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
  //     const blob = new Blob([data]);
  //     fs.saveAs(blob, 'Salary_Bill.xlsx')
  //   })
  // }

  exportExcel(billObj: any, header: any, erpUser: any) {

    var sections = Object.keys(billObj);
    if (sections.length === 0) {
      Swal.fire('INFO', 'No Data Found', 'info');
      return;
    }

    this.spinner.show();

    let data_to_print: any = []
    let list: any = []
    var count = 0;
    for (var i = 0; i < sections.length; i++) {
      var data = billObj[sections[i]];

      // list = ['Emp\nDetail'];
      list = ['SI NO'];
      list.push('Emp Id')
      list.push('Emp Name')
      // list.push('Designation') 
      // list.push('Section Code')
      // ['Emp\nName'];
      let data_keys = [];
      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'PAY') {
          list.push(this.all_component[i]['component_code'])
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      list.push('Total');
      data_keys.push('gross_pay');

      for (let i = 0; i < this.all_component.length; i++) {
        if (this.all_component[i]['pay_code'] == 'DED') {
          list.push(this.all_component[i]['component_code']);
          data_keys.push(this.all_component[i]['component_code'])
        }
      }
      list.push('Total Ded');
      data_keys.push('total');
      list.push('Net.\nSal.');
      data_keys.push('net');
      var emps = Object.keys(data['data']);
      count = count + emps.length;

      var total_obj: any = new Object();

      total_obj['si_no'] = 'Total'
      total_obj['emp_info'] = ''
      total_obj['emp_name'] = ''
      // total_obj['designation']=''
      // total_obj['Section_code']=''
      for (var j = 0; j < emps.length; j++) {
        var obj: any = data['data'][emps[j]];
        var arr: any = [];
        // var str:any = obj['emp_id'] + "\n" + obj['emp_name']
        var str: any = obj['emp_id']
        var str1: any = obj['emp_name']

        arr.push(j + 1)
        arr.push(str);
        arr.push(str1);
        // arr.push(obj['designation_code'])
        // arr.push(obj['leaf_value'])
        for (let x = 0; x < data_keys.length; x++) {
          if (total_obj[data_keys[x]] == undefined) {
            total_obj[data_keys[x]] = Number(obj[data_keys[x]].toFixed(0))
          } else {
            total_obj[data_keys[x]] = total_obj[data_keys[x]] + Number(obj[data_keys[x]].toFixed(0))
          }

          arr.push(Number(obj[data_keys[x]].toFixed(0)))
        }

        data_to_print.push(arr)
      }
      data_to_print.push(Object.values(total_obj))
    }

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('salary_bill');


    var title = erpUser['account_name'] + "(" + erpUser['account_short_name'] + ")" + "   " + header['bill_desc'] + "   Date: " + header['accrual_date'];

    //Add Row and formatting
    let titleRow = worksheet.addRow([title]);
    titleRow.alignment = { vertical: 'distributed', horizontal: 'center' };
    titleRow.font = { size: 14, bold: true }


    worksheet.mergeCells('A1:AL2');
    worksheet.getCell('A1').border = { top: { style: 'thick' }, left: { style: 'thick' }, bottom: { style: 'thick' }, right: { style: 'thick' } };

    // let header_arr = ['Emp Detail', 'BASIC', 'CCA', 'Comp Alw', 'CONV', 'DA', 'DEP-ALLOW', 'HRA', 'HVDT Allow', 'MED', 'Per Pay',
    //   'Res Alw', 'WA', 'Handicapped Allowance', 'PR BHATTA', 'Washing Allowance', 'Total', 'Comp-Loan', 'Cons-Loan', 'CPF/GPF Ded', 'Fest Adv',
    //   'GIS', 'H. RENT', 'HB Adv', 'HDFC', 'L Tax', 'Misc Ded', 'NPS', 'Other Adv', 'Other Ded', 'PF', 'PF Advance', 'Veh Loan', 'WF', 'E.P.F',
    //   'IT', 'Total Ded', 'Net.Sal'

    // ]

    const rowIndex: any = 3;
    list.map((x: any, colIndex: any) => {
      worksheet.getCell(rowIndex, colIndex + 1).value = x;
      worksheet.getCell(rowIndex, colIndex + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
      worksheet.getCell(rowIndex, colIndex + 1).alignment = { vertical: 'distributed', horizontal: 'center' };
      worksheet.getCell(rowIndex, colIndex + 1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      worksheet.getCell(rowIndex, colIndex + 1).font = { size: 10, bold: true }
    })



    //inserting data
    data_to_print.forEach((d: any, i: any) => {
      let row = worksheet.addRow(d);
      row.alignment = { vertical: 'distributed', horizontal: 'center' }
      if (i === data_to_print.length - 1) {
        row.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' }, bgColor: { argb: 'FF0000FF' } }
        row.alignment = { vertical: 'distributed', horizontal: 'center' };
        row.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        row.font = { size: 12, bold: true }

      }
    });

    this.spinner.hide();
    //  save excel file
    workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
      const blob = new Blob([data]);
      fs.saveAs(blob, 'Salary_Bill.xlsx')
    })
  }



  async convertData(originalData: any) {
    const newData: any = [];

    for (const key in originalData) {
      const monthData: any = originalData[key];
      const monthObj: any = {};

      for (const monthName in monthData) {
        const payComponents = monthData[monthName];
        const dueData: any = {};
        const drawnData: any = {};

        payComponents.forEach((component: any) => {
          const { pay_component_code, due_data, drawn_data } = component;
          dueData[pay_component_code] = due_data;
          drawnData[pay_component_code] = drawn_data;
        });

        monthObj[monthName] = {
          due_Data: dueData,
          drawn_Data: drawnData
        };
      }

      newData.push(monthObj);
    }

    return newData;
  }



  promotion_dt: any = []
  employee_detail: any = []
  async getlvl2cd(emp_id: number) {
    let obj1: any = {}
    obj1['module_cd'] = 'HR'
    obj1['node_cd'] = emp_id
    obj1['b_acct_id'] = this.b_acct_id
    obj1['status'] = 'ACTIVE'

    let resp1 = await this.payrollService.getlvl22(JSON.stringify(obj1));
    if (resp1['error'] == false) {


      this.promotion_dt = []
      this.employee_detail = []
      // this.Obj['lvl2_cd'] = resp1['data'][0]['lvl2_cd']
      // this.Obj['lvl2_value'] = resp1['data'][0]['lvl2_value']
      // this.Obj['leaf_cd'] = resp1['data'][0]['leaf_cd']
      this.employee_detail = resp1['data1']
      this.promotion_dt = resp1['promotion_Dt']
    }
  }

  async printAcpArrearById(bill_id: number) {
    this.spinner.show()
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj['bill_id'] = bill_id
    let resp = await this.payrollService.getACPArrierById(JSON.stringify(obj))
    if (resp["error"] == false) {

      let data = resp.data;
      let emp_id = data?.[0]?.['emp_id']
      if (!emp_id) {
        Swal.fire('INFO', 'Error while gethering data.', 'info')
        return;
      }

      await this.getlvl2cd(emp_id)

      let printdata = []
      for (let i = 0; i < data.length; i++) {
        printdata[i] = JSON.parse(data[i]["pay_comp"])
      }


      let formattedData = await this.convertData(printdata);


      let empdetail: any = this.employee_detail.find((item: any) => item.emp_id == emp_id);



      //////////////////////////////////////print extra arrear employees data ///////////////////////////////////////////////////////////////////

      let account_name = this.erpUser['account_name'];
      let account_short_name = this.erpUser['account_short_name'];
      let txt = account_name + "(" + account_short_name + ") \n";
      let dd: any = {
        pageSize: 'A4',
        header: function (currentPage: any, pageCount: any) {
          let arr = []
          let obj = { text: txt, alignment: 'center', margin: [72, 40], fontSize: 15, bold: true };
          arr.push(obj);
          return arr;
        },
        pageOrientation: 'landscape',
        pageMargins: [40, 60, 40, 60],
        content: []
      };
      dd.content.push({ canvas: [{ type: 'line', x1: 0, y1: 0, x2: 3000, y2: 0, lineWidth: 0.2 }] }); //x2:760
      dd.content.push({ text: " " });
      var header01 = {
        columns: [
          {
            width: '*',
            text: this.mainService.accInfo['address'],
            bold: true,
            alignment: 'center'
          }
        ],

      }
      // dd.content.push({ text: " " });
      dd.content.push(header01)
      dd.content.push({ text: " " });
      var header02 = {
        columns: [
          {
            width: '*',
            text: data?.[0]?.['arrear_type'] + ' OF ' + empdetail.emp_name + ' , ' + empdetail.designation_code + ' , ' + empdetail["work_city"],
            bold: true,
            alignment: 'center'
          }
        ],

      }
      // dd.content.push({ text: " " });
      dd.content.push(header02)
      dd.content.push({ text: " " });


      let tbl1 = {
        fontSize: 10,
        table: {
          headerRows: 2,
          // widths: ['*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*'], //DA %
          widths: ['*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*'],
          body: [
            [
              { colSpan: 6, text: 'DRAWN', alignment: 'center', bold: true },
              // {},
              {},
              {},
              {},
              {},
              {},
              { colSpan: 4, text: 'DUE', alignment: 'center', bold: true },
              {},
              {},
              {},
              { rowSpan: 2, text: 'DIFF', alignment: 'center', bold: true }

            ],

            [
              { text: 'Employee Id and name ', alignment: 'center', bold: true },
              { text: 'Year', alignment: 'center', bold: true },
              // { text: 'D.A. @', alignment: 'center', bold: true }, //DA %
              { text: 'BASIC', alignment: 'center', bold: true },
              { text: 'DA', alignment: 'center', bold: true },
              { text: 'HRA', alignment: 'center', bold: true },
              { text: 'GROSS', alignment: 'center', bold: true },
              { text: 'BASIC', alignment: 'center', bold: true },
              { text: 'DA', alignment: 'center', bold: true },
              { text: 'HRA', alignment: 'center', bold: true },
              { text: 'GROSS', alignment: 'center', bold: true },
              {}

            ],
          ],
        }
      };
      // dd.content.push(tbl1);



      let arr: any = []
      for (let i = 0; i < formattedData.length; i++) {
        arr[i] = Object.keys(formattedData[i])
      }

      let diff_amt: any = 0
      let flag: any = true
      let total: any = { 'drawn_Data': { 'BASIC': 0, 'DA': 0, 'HRA': 0, 'total_pay': 0, }, 'due_Data': { 'BASIC': 0, 'DA': 0, 'HRA': 0, 'total_pay': 0, } }
      for (let i = 0; i < arr.length; i++) {
        var push_arr: any = []
        if (flag) {
          push_arr.push(empdetail.emp_name + '-' + empdetail.designation_code + ' - ' + empdetail["work_city"] + ' from ' + moment(this.promotion_dt[0]['promotion_date']).format('YYYY-MM-DD'))
          push_arr.push(arr[i])
          // push_arr.push('') //DA %
          push_arr.push(formattedData[i][arr[i]]['drawn_Data']['BASIC'])
          push_arr.push(formattedData[i][arr[i]]['drawn_Data']['DA'])
          push_arr.push(formattedData[i][arr[i]]['drawn_Data']['HRA'])
          push_arr.push(formattedData[i][arr[i]]['drawn_Data']['total_pay'])
          push_arr.push(formattedData[i][arr[i]]['due_Data']['BASIC'])
          push_arr.push(formattedData[i][arr[i]]['due_Data']['DA'])
          push_arr.push(formattedData[i][arr[i]]['due_Data']['HRA'])
          push_arr.push(formattedData[i][arr[i]]['due_Data']['total_pay'])
          push_arr.push((formattedData[i][arr[i]]['due_Data']['total_pay']) - (formattedData[i][arr[i]]['drawn_Data']['total_pay']))
          tbl1.table.body.push(push_arr);
          total['drawn_Data']['BASIC'] += parseInt(formattedData[i][arr[i]]['drawn_Data']['BASIC'])
          total['drawn_Data']['DA'] += parseInt(formattedData[i][arr[i]]['drawn_Data']['DA'])
          total['drawn_Data']['HRA'] += parseInt(formattedData[i][arr[i]]['drawn_Data']['HRA'])
          total['drawn_Data']['total_pay'] += parseInt(formattedData[i][arr[i]]['drawn_Data']['total_pay'])
          total['due_Data']['BASIC'] += parseInt(formattedData[i][arr[i]]['due_Data']['BASIC'])
          total['due_Data']['DA'] += parseInt(formattedData[i][arr[i]]['due_Data']['DA'])
          total['due_Data']['HRA'] += parseInt(formattedData[i][arr[i]]['due_Data']['HRA'])
          total['due_Data']['total_pay'] += parseInt(formattedData[i][arr[i]]['due_Data']['total_pay'])
          let aa = 0
          aa = (formattedData[i][arr[i]]['due_Data']['total_pay']) - (formattedData[i][arr[i]]['drawn_Data']['total_pay'])
          diff_amt += aa
          flag = false
        } else {
          push_arr.push('')
          push_arr.push(arr[i])
          // push_arr.push('') //DA %
          push_arr.push(formattedData[i][arr[i]]['drawn_Data']['BASIC'])
          push_arr.push(formattedData[i][arr[i]]['drawn_Data']['DA'])
          push_arr.push(formattedData[i][arr[i]]['drawn_Data']['HRA'])
          push_arr.push(formattedData[i][arr[i]]['drawn_Data']['total_pay'])
          push_arr.push(formattedData[i][arr[i]]['due_Data']['BASIC'])
          push_arr.push(formattedData[i][arr[i]]['due_Data']['DA'])
          push_arr.push(formattedData[i][arr[i]]['due_Data']['HRA'])
          push_arr.push(formattedData[i][arr[i]]['due_Data']['total_pay'])
          push_arr.push((formattedData[i][arr[i]]['due_Data']['total_pay']) - (formattedData[i][arr[i]]['drawn_Data']['total_pay']))
          tbl1.table.body.push(push_arr);
          total['drawn_Data']['BASIC'] += parseInt(formattedData[i][arr[i]]['drawn_Data']['BASIC'])
          total['drawn_Data']['DA'] += parseInt(formattedData[i][arr[i]]['drawn_Data']['DA'])
          total['drawn_Data']['HRA'] += parseInt(formattedData[i][arr[i]]['drawn_Data']['HRA'])
          total['drawn_Data']['total_pay'] += parseInt(formattedData[i][arr[i]]['drawn_Data']['total_pay'])
          total['due_Data']['BASIC'] += parseInt(formattedData[i][arr[i]]['due_Data']['BASIC'])
          total['due_Data']['DA'] += parseInt(formattedData[i][arr[i]]['due_Data']['DA'])
          total['due_Data']['HRA'] += parseInt(formattedData[i][arr[i]]['due_Data']['HRA'])
          total['due_Data']['total_pay'] += parseInt(formattedData[i][arr[i]]['due_Data']['total_pay'])
          let aa = 0
          aa = (formattedData[i][arr[i]]['due_Data']['total_pay']) - (formattedData[i][arr[i]]['drawn_Data']['total_pay'])
          diff_amt += aa
        }
        // if(printdata[arr[i]])


      }
      push_arr = []
      push_arr.push('')
      push_arr.push('FINAL TOTAL')
      // push_arr.push('') //DA %
      push_arr.push(total['drawn_Data']['BASIC'])
      push_arr.push(total['drawn_Data']['DA'])
      push_arr.push(total['drawn_Data']['HRA'])
      push_arr.push(total['drawn_Data']['total_pay'])
      push_arr.push(total['due_Data']['BASIC'])
      push_arr.push(total['due_Data']['DA'])
      push_arr.push(total['due_Data']['HRA'])
      push_arr.push(total['due_Data']['total_pay'])
      push_arr.push(diff_amt)
      tbl1.table.body.push(push_arr);
      dd.content.push(tbl1);
      this.spinner.hide()
      // pdfMake.createPdf(dd).download('ACP-ARREAR' + '.pdf');
      pdfMake.createPdf(dd).open();
    } else {
      this.spinner.hide()
    }
  }

  getBase64ImageFromURL(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = () => {
        let canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        let ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = error => reject(error);
      img.src = url;
    });
  }

  convertNumberToWords(amount: number): string {
    const words = require('number-to-words'); // npm install number-to-words
    return words.toWords(amount).replace(/\b\w/g, (l: string) => l.toUpperCase());
  }







  async printGratuityDetails(gratuity_id: number) {
    const resp = await this.gratuityService.gratuityById(JSON.stringify({ b_acct_id: this.b_acct_id, gratuity_id: gratuity_id })) //this.getDataByID(element);

    if (resp['error'] == false) {

      let receivedData = resp.data[0];
      let data = JSON.parse(receivedData.data)
      receivedData = { ...receivedData, ...data }
      receivedData['designation_code'] = this.mainService?.codeValueShowObj['HR0011']?.[data.designation_code];
      receivedData['emp_sex'] = this.mainService?.codeValueShowObj['HR0008']?.[data['emp_sex']]
      let headerlogo = await this.getBase64ImageFromURL('../../../../../assets/img/upneda_logo.png');
      const now = new Date();

      const headerObj = {
        agencyLine1: 'UTTAR PRADESH NEW & RENEWABLE ENERGY AGENCY,',
        agencyLine2: 'VIBHUTI KHAND GOMTI NAGAR, LUCKNOW',
        date: now.toLocaleDateString('en-GB'),
        time: now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
      }


      const line = (width = 515, color = '#BDBDBD') => ({
        canvas: [{ type: 'line', x1: 0, y1: 0, x2: width, y2: 0, lineWidth: 0.5, lineColor: color }],
        margin: [0, 10, 0, 10],
      });



     const iconCalendar = {
        canvas: [
          { type: 'rect', x: 0, y: 1.5, w: 9, h: 7, r: 2, lineWidth: 0.7, lineColor: '#4A4A4A' },
          { type: 'rect', x: 0, y: 0, w: 9, h: 2.5, r: 2, lineWidth: 0.7, lineColor: '#4A4A4A', color: '#E0E0E0' },
          { type: 'line', x1: 3, y1: 0, x2: 3, y2: 2.5, lineWidth: 0.7, lineColor: '#4A4A4A' },
          { type: 'line', x1: 6, y1: 0, x2: 6, y2: 2.5, lineWidth: 0.7, lineColor: '#4A4A4A' },
        ],
        width: 10,
        margin: [0, 0, 3, 0],
      };

      const iconClock = {
        canvas: [
          { type: 'ellipse', x: 5, y: 5, r1: 5, r2: 5, lineWidth: 0.7, lineColor: '#4A4A4A' },
          { type: 'line', x1: 5, y1: 5, x2: 5, y2: 2, lineWidth: 0.7, lineColor: '#4A4A4A' },
          { type: 'line', x1: 5, y1: 5, x2: 8, y2: 5, lineWidth: 0.7, lineColor: '#4A4A4A' },
        ],
        width: 9,
        margin: [0, 0, 0, 0],
      };

      const withIcon = (icon: any, text: string) => ({
        columns: [
          { width: 'auto', ...icon },
          { width: 'auto', text, style: 'meta' },
        ],
        columnGap: 4,
      });

      const docDefinition: any = {
        pageSize: 'A4',
        pageMargins: [36, 36, 36, 36],
        defaultStyle: { fontSize: 10 },
        background: (currentPage: number, pageSize: any) => {
          return {
            image: headerlogo,
            width: (pageSize.width - 72), // set size
            height: 180,
            opacity: 0.07, // transparency
            absolutePosition: { x: 36, y: 300 } // position
          };
        },
        content: [
          {
            image: headerlogo, // your base64
            width: 100,
            alignment: 'center',
            margin: [0, 0, 0, 12],
          },
          // Letterhead
          { text: headerObj.agencyLine1, alignment: 'center', style: 'header' },
          { text: headerObj.agencyLine2, alignment: 'center', style: 'header', margin: [0, 0, 0, 8] },
          line(),
           {
            columns: [
              // { text: '', width: '*' },
              { alignment: 'left', margin: [0, 0, 0, 0], width: '82%', ...withIcon(iconCalendar, `Date: ${headerObj.date}`) },
              // { width: 12, text: '' },
              { alignment: 'right', margin: [0, 0, 0, 0], width: '18%', ...withIcon(iconClock, `Time: ${headerObj.time}`) },
            ],
            // columnGap: 330,
            margin: [0, 0, 0, 25]
          },

        ],

        styles: {
          header: { fontSize: 15, bold: true },
          subheader: { fontSize: 11, bold: true },
          label: { bold: true },
          meta: { fontSize: 10 },
          note: { fontSize: 9, color: 'red' },
        },
      };

      const section = {
        table: {
          widths: ['*'], // full available width
          body: [
            [
              {
                text: 'Gratuity Details',
                alignment: 'center', // center text
                fontSize: 14,
                bold: true,
                margin: [0, 7, 0, 7], // padding: [left, top, right, bottom]
                fillColor: '#ECFDEE'    // background color
              }
            ]
          ]
        },
        layout: 'noBorders' // remove table borders
      }


      const tableData: any = [
        // ---- EMPLOYEE INFO ----
        {
          columns: [
            {
              width: '50%',
              text: [
                { text: 'Employee ID: ', bold: true },
                { text: receivedData.emp_id }
              ],
              fontSize: 11
            },
            {
              width: '50%',
              text: [
                { text: 'Name of the Employee: ', bold: true },
                { text: receivedData.emp_name }
              ],
              fontSize: 11
            }
          ],
          columnGap: 60,
          margin: [0, 20, 0, 12]
        },
        {
          columns: [
            {
              width: '50%',
              text: [
                { text: 'Date of Birth: ', bold: true },
                { text: receivedData.emp_dob }
              ],
              fontSize: 11
            },
            {
              width: '50%',
              text: [
                { text: 'Gender: ', bold: true },
                { text: receivedData.emp_sex ?? '' }
              ],
              fontSize: 11
            }
          ],
          columnGap: 60,
          margin: [0, 0, 0, 12]
        },
        {
          columns: [
            {
              width: '50%',
              text: [
                { text: 'Designation: ', bold: true },
                { text: receivedData.designation_code }
              ],
              fontSize: 11
            },
            {
              width: '50%',
              text: [
                { text: 'Employee DOJ: ', bold: true },
                { text: receivedData.joining_date }
              ],
              fontSize: 11
            }
          ],
          columnGap: 60,
          margin: [0, 0, 0, 12]
        },
        {
          columns: [
            {
              width: '50%',
              text: [
                { text: 'Employee DOR: ', bold: true },
                { text: receivedData.retirement_date }
              ],
              fontSize: 11
            },
            {
              width: '50%',
              text: [
                { text: 'Last Paid Salary: ', bold: true },
                { text: receivedData.da_and_basic }
              ],
              fontSize: 11
            }
          ],
          columnGap: 60,
          margin: [0, 0, 0, 12]
        },

        // ---- SALARY DETAILS ----
        {
          columns: [
            {
              width: '50%',
              text: [
                { text: 'Basic Pay: ', bold: true },
                { text: receivedData.basic }
              ],
              fontSize: 11
            },
            {
              width: '50%',
              text: [
                { text: 'DA: ', bold: true },
                { text: receivedData.da }
              ],
              fontSize: 11
            }
          ],
          columnGap: 60,
          margin: [0, 0, 0, 12]
        },

        {
          text: [
            { text: 'Service Year: ', bold: true },
            { text: `${receivedData.service_year} years ${receivedData.service_month} months` }
          ],
          fontSize: 11,
          margin: [0, 0, 0, 15]
        },

        // ---- GRATUITY CALCULATION ----


        // {
        //   text: [
        //     { text: 'Gratuity Calculation '+ `${receivedData.formulda_for_calculation}: `, bold: true },
        //     { text: `${receivedData.calculated_gratuity}` }
        //   ],
        //   fontSize: 11,
        //   margin: [0, 0, 0, 15]
        // },
        // {
        //   text: [
        //     { text: `${receivedData.formulda_for_calculation}: `, bold: true },
        //     { text: receivedData.calculated_gratuity }
        //   ],
        //   fontSize: 11
        // },
        // {
        //   text: [
        //     { text: 'Total Gratuity Amount: ', bold: true },
        //     { text: receivedData.gratuity_amount }
        //   ],
        //   fontSize: 11,
        //   margin: [0, 0, 0, 12]
        // },
        {
          columns: [
            {
              width: '50%',
              text: [
                { text: 'Gratuity Calculation' + `${receivedData.formulda_for_calculation}: `, bold: true },
                { text: `${receivedData.calculated_gratuity}` }
              ],
              fontSize: 11
            },
            {
              width: '50%',
              text: [
                { text: 'Total Gratuity Amount:', bold: true },
                { text: receivedData.gratuity_amount }
              ],
              fontSize: 11
            }
          ],
          columnGap: 60,
          margin: [0, 0, 0, 12]
        },
        {
          text: [
            { text: 'Total Payable Gratuity Amount: ', bold: true },
            { text: receivedData.payable_gratuity_amount }
          ],
          fontSize: 11,
          margin: [0, 0, 0, 12]
        },
        {
          text: [
            { text: 'Total Payable Gratuity Amount in words: ', },
            { text: this.convertNumberToWords(receivedData.payable_gratuity_amount), bold: true }
          ],
          fontSize: 11,
          margin: [0, 0, 0, 15]
        },

        // ---- NOTE ----
        {
          text: `Note: As per Government rules and regulations, the maximum payable amount towards gratuity is ₹25,00,000 (Rupees Twenty-Five Lakh Only). No payment beyond this limit shall be made.`,
          style: 'note',
          fontSize: 11,
          margin: [0, 10, 0, 0]
        }
      ];

      docDefinition.content.push(section);
      docDefinition.content.push(tableData)
      pdfMake.createPdf(docDefinition).open();
      return { error: false }
    } else {
      Swal.fire('Error', 'Error while printing gratuity.', 'error')
      return { error: true }
    }













  }



  async printLeaveEncashmentDetails(leave_encashment: number) {

    const resp = await this.payrollService.getLeaveEncashment(JSON.stringify({ b_acct_id: this.b_acct_id, leave_encashment: leave_encashment })) //this.getDataByID(element);

    if (resp['error'] == false) {
      let receivedData = resp.data[0];
      receivedData['designation_code'] = this.mainService?.codeValueShowObj['HR0011']?.[receivedData.designation_code];
      let headerlogo = await this.getBase64ImageFromURL('../../../../../assets/img/upneda_logo.png');
      const now = new Date();

      const headerObj = {
        agencyLine1: 'UTTAR PRADESH NEW & RENEWABLE ENERGY AGENCY,',
        agencyLine2: 'VIBHUTI KHAND GOMTI NAGAR, LUCKNOW',
        date: now.toLocaleDateString('en-GB'),
        time: now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
      }
      const line = (width = 515, color = '#BDBDBD') => ({
        canvas: [{ type: 'line', x1: 0, y1: 0, x2: width, y2: 0, lineWidth: 0.5, lineColor: color }],
        margin: [0, 10, 0, 10],
      });


      const iconCalendar = {
        canvas: [
          { type: 'rect', x: 0, y: 1.5, w: 9, h: 7, r: 2, lineWidth: 0.7, lineColor: '#4A4A4A' },
          { type: 'rect', x: 0, y: 0, w: 9, h: 2.5, r: 2, lineWidth: 0.7, lineColor: '#4A4A4A', color: '#E0E0E0' },
          { type: 'line', x1: 3, y1: 0, x2: 3, y2: 2.5, lineWidth: 0.7, lineColor: '#4A4A4A' },
          { type: 'line', x1: 6, y1: 0, x2: 6, y2: 2.5, lineWidth: 0.7, lineColor: '#4A4A4A' },
        ],
        width: 10,
        margin: [0, 0, 3, 0],
      };

      const iconClock = {
        canvas: [
          { type: 'ellipse', x: 5, y: 5, r1: 5, r2: 5, lineWidth: 0.7, lineColor: '#4A4A4A' },
          { type: 'line', x1: 5, y1: 5, x2: 5, y2: 2, lineWidth: 0.7, lineColor: '#4A4A4A' },
          { type: 'line', x1: 5, y1: 5, x2: 8, y2: 5, lineWidth: 0.7, lineColor: '#4A4A4A' },
        ],
        width: 9,
        margin: [0, 0, 0, 0],
      };

      const withIcon = (icon: any, text: string) => ({
        columns: [
          { width: 'auto', ...icon },
          { width: 'auto', text, },
        ],
        columnGap: 4,
      });

      const docDefinition: any = {
        pageSize: 'A4',
        pageMargins: [36, 36, 36, 36],
        defaultStyle: { fontSize: 10 },
        background: (currentPage: number, pageSize: any) => {
          return {
            image: headerlogo,
            width: (pageSize.width - 72), // set size
            height: 180,
            opacity: 0.07, // transparency
            absolutePosition: { x: 36, y: 300 } // position
          };
        },
        content: [
          {
            image: headerlogo, // your base64
            width: 100,
            alignment: 'center',
            margin: [0, 0, 0, 12],
          },
          // Letterhead
          { text: headerObj.agencyLine1, alignment: 'center', style: 'header' },
          { text: headerObj.agencyLine2, alignment: 'center', style: 'header', margin: [0, 0, 0, 8] },
          line(),
          {
            columns: [
              // { text: '', width: '*' },
              { alignment: 'left', margin: [0, 0, 0, 0], width: '82%', ...withIcon(iconCalendar, `Date: ${headerObj.date}`) },
              // { width: 12, text: '' },
              { alignment: 'right', margin: [0, 0, 0, 0], width: '18%', ...withIcon(iconClock, `Time: ${headerObj.time}`) },
            ],
            // columnGap: 330,
            margin: [0, 0, 0, 25]
          },

        ],

        styles: {
          header: { fontSize: 15, bold: true },
          subheader: { fontSize: 11, bold: true },
          label: { bold: true },
          meta: { fontSize: 10 },
          note: { fontSize: 9, color: 'red' },
        },
      };

      const section = {
        table: {
          widths: ['*'], // full available width
          body: [
            [
              {
                text: 'Leave Encashment Details',
                alignment: 'center', // center text
                fontSize: 14,
                bold: true,
                margin: [0, 7, 0, 7], // padding: [left, top, right, bottom]
                fillColor: '#ECFDEE'    // background color
              }
            ]
          ]
        },
        layout: 'noBorders' // remove table borders
      }


      const tableData: any = [
        // ---- EMPLOYEE INFO ----
        {
          columns: [
            {
              width: '50%',
              text: [
                { text: 'Employee ID: ', bold: true },
                { text: receivedData.emp_id }
              ],
              fontSize: 11
            },
            {
              width: '50%',
              text: [
                { text: 'Name of the Employee: ', bold: true },
                { text: receivedData.emp_name }
              ],
              fontSize: 11
            }
          ],
          columnGap: 60,
          margin: [0, 20, 0, 12]
        },

        {
          columns: [
            {
              width: '50%',
              text: [
                { text: 'Designation: ', bold: true },
                { text: receivedData.designation_code }
              ],
              fontSize: 11
            },
            {
              width: '50%',
              text: [
                { text: 'BASIC + DA : ', bold: true },
                { text: receivedData.da_and_basic }
              ],
              fontSize: 11
            }
          ],
          columnGap: 60,
          margin: [0, 0, 0, 12]
        },
        {
          columns: [
            {
              width: '50%',
              text: [
                { text: 'Basic Pay: ', bold: true },
                { text: receivedData.basic }
              ],
              fontSize: 11
            },
            {
              width: '50%',
              text: [
                { text: 'DA: ', bold: true },
                { text: receivedData.da }
              ],
              fontSize: 11
            }
          ],
          columnGap: 60,
          margin: [0, 0, 0, 12]
        },

        // ---- SALARY DETAILS ----
        {
          columns: [
            {
              width: '50%',
              text: [
                { text: 'Number Of Remaining Leaves: ', bold: true },
                { text: receivedData.remaining_leaves }
              ],
              fontSize: 11
            },
            {
              width: '50%',
              text: [
                { text: 'Due Amount: ', bold: true },
                { text: receivedData.due_amount }
              ],
              fontSize: 11
            }
          ],
          columnGap: 60,
          margin: [0, 0, 0, 12]
        },



        {
          text: [
            { text: 'Total Leave Encashment Amount: ', bold: true },
            { text: receivedData.total_leave_encashment }
          ],
          fontSize: 11,
          margin: [0, 0, 0, 12]
        },
        {
          text: [
            { text: 'Total Net Payable Leave Encashment Amount: ', bold: true },
            { text: receivedData.total_payable_leave_encashment }
          ],
          fontSize: 11,
          margin: [0, 0, 0, 12]
        },
        {
          text: [
            { text: 'Total Net Payable Leave Encashment Amount in words: ', },
            { text: this.convertNumberToWords(receivedData.total_payable_leave_encashment), bold: true }
          ],
          fontSize: 11,
          margin: [0, 0, 0, 15]
        },


      ];

      docDefinition.content.push(section);
      docDefinition.content.push(tableData)
      pdfMake.createPdf(docDefinition).open();
      return { error: false }
    } else {
      Swal.fire('Error', 'Error while printing leave encashment.', 'error')
      return { error: true }
    }













  }





}
